import React, { useEffect, useRef, useState } from "react";
import {
  Avatar,
  Box,
  Divider,
  IconButton,
  Button,
  FormControl,
  Typography,
  MenuItem,
  InputLabel,
  Drawer,
  TextField,
  Slider,
  Radio,
  RadioGroup,
  FormControlLabel,
  ToggleButtonGroup,
  ToggleButton,
  styled,
  Menu,
  Dialog,
  DialogContent,
  Select,
  DialogTitle,
  DialogContentText,
  DialogActions,
  Alert,
  Autocomplete,
} from "@mui/material";
import imglogo from "../../../assets/Project_Images/Icons/imagelogo.png";
import direction from "../../../assets/Project_Images/Icons/direction.png";
import brief from "../../../assets/Project_Images/Icons/brief.png";
import print from "../../../assets/Project_Images/Icons/print.png";
import calender from "../../../assets/Project_Images/Icons/calaneder.png";
import sad from "../../../assets/Project_Images/sad (2).png";
import ALDI from '../../../assets/Project_Images/Aldi_logo.png'
import BLOOMS from '../../../assets/Project_Images/Blooms_logo.png'
import MM from '../../../assets/Project_Images/MM_logo.png'
import { Form, Link, useLocation, useNavigate } from "react-router-dom";

import {
  LocalizationProvider,
  DatePicker,
  StaticDatePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import {
  AccessTimeOutlined,
  CancelOutlined,
  Circle,
  DoneAll,
  InfoOutlined,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  Label,
  MoreVert,
  ReportProblemOutlined,
  ScheduleSendOutlined,
  Watch,
  WestOutlined,
} from "@mui/icons-material";
import {
  ApiBookTrainingSlots,
  ApiCancelAppliedAllocation,
  ApiCancelBundle,
  ApiCancelJob,
  ApiDeleteAppliedAllocation,
  ApiFinalAcceptedByShopper,
  ApiGetAllocationCriteriaDetails,
  ApiGetNewBrief,
  ApiGetQuiz,
  APiGetTimeSelection,
  ApiGetTrainingSlots,
  ApiGetVenueForTransport,
  ApiRequestNewDateTime,
  ApiSelectVenueForTransport,
  ApiSubmitQuiz,
  appliedAllocations,

  getVisitTimes,
  UpdateDateTime,
} from "../../../apiService/Core/Apicall.tsx";
import { hideLoading, showLoading } from "../../../Redux/loadingSlice.tsx";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../Loader/Loading.tsx";
import clsx from "clsx";
import { ErrorMessage, Formik, useFormik } from "formik";
import * as Yup from "yup";
import { AppDispatch, RootState } from "../../../Redux/Store.tsx";
import { findData, setData } from "../../../Redux/GetTimeSlice.tsx";
import { updateDateandTime } from "../../../apiService/Core/ApiEndPoint.tsx";
import { toast, ToastContainer } from "react-toastify";
import { ApiCallCreateReport, ApiCheckInCheckOutShopper } from "../../../apiService/Core/CustomApiScoreCards.tsx";
import { fetchClientList, setSelectedClientGroupName } from "../../../Redux/clientSlice.tsx";
import { setSelectedMonth } from "../../../Redux/MonthSlice.tsx";
import utc from "dayjs/plugin/utc";
import ReadBrief from "./ReadBrief.tsx";
interface FormValues {
  appliedAllocationId: string;
  selectedVisitTime: string;
  selectedVisitDate: string;
}
function MyTask() {
  const defaultMonth = useSelector((state: RootState) => state.month.selectedMonth)
  const [SelectedAction, setSelectedAction] = useState<string>("");
  const [CancelReason, setCancelReason] = useState<string>("");
  const [CancelReason2, setCancelReason2] = useState<string>("");
  const [totalallocation, setAllocation] = useState<any>();
  const [OpenDialog, setOpenDialog] = useState<boolean>(false);
  const [OpenTrainingDialog, setOpenTrainigDialog] = useState<boolean>(false);
  const [showselectvenue, setshowselectvenue] = useState<boolean>(false);
  const [isReload, setisReload] = useState<boolean>(false);
  const [OpenDeleteConfirm, setOpenDeleteConfirm] = useState<boolean>(false);
  const [OpenCancel, setOpenCancel] = useState<boolean>(false);
  const [isshowerror, setisshowerror] = useState<boolean>(false);
  const [isdelete, setisdelete] = useState<boolean>(false);
  const [RequestNewTime, setRequestNewTime] = useState<boolean>(false);
  const [isneeddatechange, setisneeddatechange] = useState<boolean>(false);
  const [isshopperconfirm, setisshopperconfirm] = useState<boolean>(false);
  const loading = useSelector((state: any) => state.loader.isLoading);
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [filtervalue, setfiltervalue] = React.useState<any>();
  const [allocationCriteria, setAllocationCriteria] = useState<any>([]);
  const [dateCriteria, setDateCriteria] = useState<any>([]);
  const [trainingSlots, setTrainingSlots] = useState<any>([]);
  const [trainingallocationId, setTrainingAllocationId] = useState<any>(null);
  const cardRefs = useRef<(HTMLDivElement | null)[]>([]);
  const [selectedSlot, setSelectedSlot] = useState<any>(null);
  const filterDataFromStore = useSelector(
    (state: RootState) => state.counter.filterData
  );
  const globalclientlist = useSelector((state: RootState) => state.client.clientList2)
  const selectedclientGroup = useSelector((state: RootState) => state.client.selectedClientGroup)
  const [selectedmonth, setSelectedmonth] = useState<Dayjs>(dayjs());
  const location = useLocation();
  const { taskId, selecteddatefromcalender, activeposition } = location.state || {};
  const [selectedtaskId, setselectedtaskId] = useState(taskId)
  const appdispatch = useDispatch<AppDispatch>();
  const initialized = useRef(false);
  const [selectedDate, setSelectedDate] = useState<any>(
    selecteddatefromcalender ? dayjs(selecteddatefromcalender) : dayjs(defaultMonth)
  );
  const [datefromCalnder, setDateFromCalnder] = useState(selecteddatefromcalender)
  const [position, setposition] = useState<string>(activeposition ?? "approved");
  const [selectvenuelist, setselectvenuelist] = useState<any>([])
  const [selectedVenueforTransport, setselectedVenueforTransport] = useState<number | string>()
  const [currentPage, setCurrentPage] = useState(0);
  const [OpenNewBriefReadDialog, setOpenNewBriefReadDialog] = useState<boolean>(false);
  const [newBrief, setNewBrief] = useState<any>()
  const [quizType, setQuizType] = useState<any>()
  const [selectedOptions, setSelectedOptions] = useState<any>([]);
  const [QuizList, setQuizList] = useState<any[]>([])
  const [IsQuizSubmitted, setIsQuizSubmitted] = useState<boolean>(false);
  const [IsNeedtoCreateReport, setIsNeedtoCreateReport] = useState<boolean>(false);
  const [tempallocationCriteria, settempAllocationCriteria] = useState<any>()
  const [tempAllocation, setTempAllocation] = useState<any>()






  // const hasFetchedRef = useRef(false);


  useEffect(() => {
    if (selecteddatefromcalender) {
      setDateFromCalnder(selecteddatefromcalender)
    }
  }, [selecteddatefromcalender])

  const dates = Object.keys(trainingSlots)
    .sort((a, b) => dayjs(a).unix() - dayjs(b).unix());;
  const pageSize = 7;

  // Calculate slice range
  const start = currentPage * pageSize;
  const end = start + pageSize;

  // Get only 7 dates for current view
  const visibleDates = dates.slice(start, end);

  const handleNext = () => {
    if (end < dates.length) {
      setCurrentPage(prev => prev + 1);
    }
  };

  const handleBack = () => {
    if (currentPage > 0) {
      setCurrentPage(prev => prev - 1);
    }
  };



  useEffect(() => {
    if (filterDataFromStore) {
      setfiltervalue(filterDataFromStore);
    }
  }, [filtervalue, filterDataFromStore]);



  const [formsubmitted, setformsubmitted] = useState<boolean>(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const open = Boolean(anchorEl);

  useEffect(() => {
    appdispatch(fetchClientList());
  }, [])
  const fetchAppliedAllocations = async () => {
    const data = "?offset=0&limit=500";
    try {
      const params = {
        jobMonth: selectedDate && selectedDate.month() + 1,
        jobYear: selectedDate && selectedDate.year(),
        userId: userData.userId,
        status: position,
      };
      const res = await appliedAllocations(params, data);
      const finaldata = res.data.filter((item) => item?.allocationId.allocationClientGroup === selectedclientGroup)
      if (selectedclientGroup && selectedclientGroup !== 'All') {
        setAllocation({ ...res, data: finaldata })

      }
      else {
        setAllocation(res);
      }

      // setSelectedId()
      setSelectedId(window.innerWidth <= 576 ? null : selectedtaskId !== null ? res.data.findIndex(
        (item) => item.appliedAllocationId == selectedtaskId) : 0);
      if (selectedtaskId) {
        const tempIndex = res.data.findIndex((item: any) => item.appliedAllocationId == selectedtaskId);
        await fetchAllocationCriteria(res?.data[tempIndex]?.allocationId, res?.data[tempIndex]?.userId?.userId, res?.data[tempIndex]?.selectedVisitDate?.split(" ")[0])
      }
    } catch (error) {
      console.error("Error fetching applied allocations:", error);
    }
  };
  useEffect(() => {
    if (!selectedclientGroup || !position || !selectedDate) return;

    // if (hasFetchedRef.current) return;

    // hasFetchedRef.current = true;

    fetchAppliedAllocations();

  }, [selectedDate, position, formsubmitted, isdelete, selectedclientGroup]);
  useEffect(() => {
    if (totalallocation?.data?.length > 0) {
      setSelectedId(window.innerWidth <= 576 ? null : 0);
      const locationType = totalallocation.data[0]?.allocationId?.venueId?.locationType;
      const visitTimeArray =
        // locationType === "region"
        //   ? allocationCriteria?.regionVisitTimeInformation?.split(",").map(Number)
        //   : 
        totalallocation.data[0]?.allocationId?.visitTimeInformation?.split(",").map(Number);

      // dispatch(
      //   findData(
      //     totalallocation.data[0]?.allocationId?.visitTimeInformation
      //       .split(",")
      //       .map(Number)
      //   )
      // );
      dispatch(
        findData(
          visitTimeArray
        )
      );

      // if (position !== 'approved') { f

      !selectedtaskId && fetchAllocationCriteria(totalallocation?.data[0]?.allocationId, totalallocation?.data[0]?.userId?.userId, totalallocation?.data[0]?.selectedVisitDate?.split(" ")[0]);
    }
    // }
  }, [totalallocation]);

  const handleCallAnotherCriteria = async (item: any, isNeedToHideWeekend: boolean, isNeedToHideNonWeekend: boolean, visitTime: string) => {
    try {
      const data = `?allocationId=${item.allocationId}&venueId=${item?.venueId?.venueId}&jobMonth=${item?.jobMonth}&jobYear=${item?.jobYear}&isWeekDayJob=${isNeedToHideWeekend}&isWeekendDayJob=${isNeedToHideNonWeekend}&visitDate=${visitTime}`
      const res = await APiGetTimeSelection(data)
      if (res?.status) {
        dispatch(
          findData(
            res?.visitTimeList?.map(Number)
          )
        );
        // setDateCriteria(res?.data)
      }
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        String(error);
      console.log(message)
    }
  }


  const fetchAllocationCriteria = async (item: any, userId: number, visitTime?: string) => {
    try {
      const data = `?allocationId=${item.allocationId}&clientEntityId=${item?.venueId?.clientEntityId?.clientEntityId}&userId=${userId}`;
      const response = await ApiGetAllocationCriteriaDetails(data);
      setAllocationCriteria(response.data);
      settempAllocationCriteria(response?.data)
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        String(error);
      console.log(message)
    }

  };

  const fetchData = async () => {
    try {
      const response = await getVisitTimes();

      dispatch(setData(response.data));
    }
    catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        String(error);
      toast.error(message)
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch]);

  // Handle Previous Month
  const handlePrevMonth = () => {
    setDateFromCalnder(null)
    const newMonth = dayjs(defaultMonth).subtract(1, "month").toISOString();
    dispatch(setSelectedMonth(newMonth));
  };

  // Handle Next Month
  const handleNextMonth = () => {
    const newMonth = dayjs(defaultMonth).add(1, "month").toISOString();
    setDateFromCalnder(null)
    dispatch(setSelectedMonth(newMonth));
  };


  useEffect(() => {
    if (datefromCalnder?.length > 0) {
      setSelectedDate(dayjs(datefromCalnder));
    } else {
      setSelectedDate(dayjs(defaultMonth));
    }
  }, [defaultMonth, datefromCalnder]);

  const scrollToCard = (index: number) => {
    const card = cardRefs.current[index];
    if (card) {
      card.scrollIntoView({
        behavior: "smooth", // smooth animation
        block: "center",    // center it vertically
      });
    }
  };

  const selectcard = async (index: number) => {
    // console.log(index);
    setSelectedId(index);
    setTempAllocation(index);
    setselectedtaskId(null)
    await fetchAllocationCriteria(totalallocation.data[index || 0].allocationId, totalallocation.data[index || 0].userId.userId, totalallocation.data[index || 0]?.selectedVisitDate?.split(" ")[0])
    // setDateFromCalnder(null)
    const locationType = totalallocation?.data[index].allocationId?.venueId?.locationType;
    const visitTimeArray =
      // locationType === "region"
      //   ? allocationCriteria?.regionVisitTimeInformation?.split(",").map(Number)
      //   : 
      totalallocation?.data[index].allocationId?.visitTimeInformation?.split(",").map(Number);

    // dispatch(
    //   findData(
    //     totalallocation?.data[index].allocationId.visitTimeInformation
    //       .split(",")
    //       .map(Number)
    //   )
    // );

    dispatch(
      findData(
        visitTimeArray
      )
    );
    // if (position !== 'approved') { 
    // };

  };
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 576) {
        setSelectedId(selectedId ? selectedId : null);
      } else {
        setSelectedId(selectedId ? selectedId : 0);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handlePhoneMenue = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (option: string) => {
    setSelectedAction(option);
    setAnchorEl(null);
  };

  // console.log('Selected ALoocation', totalallocation?.data[selectedId]?.allocationId?.allocationId)
  const handleDialogOpen = async (item?: any, index?: any) => {
    try {
      console.log('Item', item)
      if (index > -1) {
        setTempAllocation(index)
      }
      const data = `?allocationId=${item?.allocationId?.allocationId}&clientEntityId=${item?.allocationId?.clientEntityId?.clientEntityId}&userId=${item?.userId?.userId}`;
      const response = await ApiGetAllocationCriteriaDetails(data);
      if (response?.status || response?.success) {
        settempAllocationCriteria(response?.data)
        if (response?.data?.isQuizRequired)
          handleOpenQuiz(item?.allocationId?.clientEntityId?.clientEntityId, item?.allocationId?.venueId?.venueId, response?.data?.isQuizRequired)
        else {
          getBrief(item?.allocationId?.venueId?.venueId, item?.allocationId?.clientEntityId?.clientEntityId)
        }
      }
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        String(error);
      toast.error(message)
      console.log(message)
    }
    // setOpenDialog(true);
  };
  const handleOpenTrainingDialog = async (allocationId: number) => {

    try {
      const data = `?allocationId=${allocationId}&userId=${parseInt(userData?.userId || "0")}`
      const res = await ApiGetTrainingSlots(data)
      if (res?.status) {
        setTrainingAllocationId(allocationId)
        setTrainingSlots(res?.data?.slots.reduce((acc: any, slot: any) => {
          const date = dayjs.utc(slot.slotStart).local().format("YYYY-MM-DD"); // "2026-01-03"
          if (!acc[date]) acc[date] = [];
          acc[date].push(slot);
          return acc;
        }, {}))

        setOpenTrainigDialog(true);
      }
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        String(error);
      toast.error(message)
    }
  };



  const handleSubmit = async () => {
    if (!selectedSlot) {
      alert("Please select a slot");
      return;
    }
    const isbook = window.confirm(
      `Are you sure you want to book your slot on ${dayjs.utc(selectedSlot.slotStart).local().format("DD MMM YYYY")} at ${dayjs.utc(selectedSlot.slotStart).local().format("hh:mm A")}?`
    );
    if (isbook) {
      try {
        const data = {
          slotId: selectedSlot?.slotId,
          shopperUserId: parseInt(userData?.userId),
          allocationId: parseInt(trainingallocationId),
          date: dayjs(selectedSlot.slotStart).local().format("DD/MM/YYYY"),
          time: dayjs.utc(selectedSlot.slotStart).local().format("hh:mm A"),
          createdBy: parseInt(userData?.userId)
        }
        // console.log("Send data ", data)
        const res = await ApiBookTrainingSlots(data)
        if (res.status) {
          toast.success("Your slot is booked is successfully")
          setSelectedSlot(null)
          setTrainingAllocationId(null)
          setTrainingSlots([])
          setOpenTrainigDialog(false)
          fetchAppliedAllocations()
        }

      } catch (error: any) {
        const message =
          error?.response?.data?.message ||
          error?.message ||
          String(error);
        toast.error(message)
      }
    }
    else {
      return
    }

  };

  const handleCloseOpen = () => {
    // setOpenCancel(true);
    setOpenDeleteConfirm(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    // setOpenCancel(true);
  };
  const handleOpenGoogleMaps = (latitude: number, longitude: number) => {
    const url = `https://www.google.com/maps?q=${latitude},${longitude}`;
    window.open(url, "_blank"); // Opens in a new tab
  };

  const handleRequestNewTimeOpen = () => {
    formik.setFieldValue("selectedVisitTime", totalallocation?.data?.[selectedId]?.selectedVisitTime?.visitTimeId)
    const locationType = totalallocation?.data?.[selectedId].allocationId?.venueId?.locationType;
    const visitTimeArray =
      // locationType === "region"
      //   ? allocationCriteria?.regionVisitTimeInformation?.split(",").map(Number)
      //   : 
      totalallocation?.data[selectedId].allocationId?.visitTimeInformation?.split(",").map(Number);

    // dispatch(
    //   findData(
    //     totalallocation?.data[index].allocationId.visitTimeInformation
    //       .split(",")
    //       .map(Number)
    //   )
    // );

    dispatch(
      findData(
        visitTimeArray
      )
    );
    setRequestNewTime(true);
  };
  const handleRequestNewTimeClose = () => {
    setRequestNewTime(false);
    formik.setFieldValue("selectedVisitTime", "")
  };
  // const shouldDisableDate = (
  //   date: Dayjs,
  //   activeMonth: any,
  //   activeYear: any,
  //   startDay: any,
  //   endDay: any,
  //   visitDaysString: string
  // ) => {
  //   // Convert visitDaysInformation to an array
  //   const allowedDays = visitDaysString.split(",").map((day) => day.trim());
  //   // console.log("Visisy Days", allowedDays);

  //   // Get full day name (e.g., "Monday")
  //   const dayName = date.format("dddd");

  //   // Disable if the day is NOT in the allowedDays array
  //   if (!allowedDays.includes(dayName)) {
  //     return true;
  //   }

  //   // Disable dates outside the active month and year
  //   if (date.month() + 1 !== activeMonth || date.year() !== activeYear) {
  //     return true;
  //   }

  //   // Disable dates outside the given range
  //   if (date.date() < startDay || date.date() > endDay) {      
  //     return true;
  //   }
  // };
  const shouldDisableDate = (
    date: Dayjs,
    activeMonth: any,
    activeYear: any,
    startDay: any,
    endDay: any,
    visitDaysString: string
  ) => {
    // Convert visitDaysInformation to an array
    const allowedDays = visitDaysString?.split(", ").map((day) => day?.trim())
    const formattedDate = date.format("YYYY-MM-DD");

    if (allocationCriteria?.holidayDates?.includes(formattedDate)) {
      return true;
    }

    if (
      allocationCriteria?.businessHolidays?.some(
        (holiday: any) => holiday?.date === formattedDate
      )
    ) {
      return true;
    }

    // Get full day name (e.g., "Monday")
    const dayName = date?.format("dddd");

    // Disable if the day is NOT in the allowedDays array
    if (!allowedDays?.includes(dayName)) {
      return true;
    }

    // Disable dates outside the active month and year
    if (date.month() + 1 !== activeMonth || date.year() !== activeYear) {
      return true;
    }

    // Disable dates outside the given range
    if (date.date() < startDay || date.date() > endDay) {
      return true;
    }

    // Hide non-weekend days 
    if (allocationCriteria?.isNeedToHideNonWeekend) {
      const weekendDays = ["Saturday", "Sunday"];
      if (!weekendDays.includes(dayName)) {
        return true; // Disable Monday to Friday
      }
    }
    // Hide weekend days 
    if (allocationCriteria?.isNeedToHideWeekend) {
      const weekendDays = ["Saturday", "Sunday"];
      if (weekendDays.includes(dayName)) {
        return true; // Disable Monday to Friday
      }
    }

    // 6. New Condition ➡️ Block same weekday as lastJobVisitedDate
    // if (
    //   allocationCriteria?.shouldBeDifferentDayFromPreviousMonth &&
    //   allocationCriteria?.lastJobVisitedDate
    // ) {
    //   const lastVisitedDayName = dayjs(
    //     allocationCriteria?.lastJobVisitedDate
    //   ).format("dddd"); // Get day name from last visited date
    //   if (dayName === lastVisitedDayName) {
    //     return true; // Block this date
    //   }

    // }

    // New Condition ➡️ Block dates if less than minDaysGapBetweenJobs
    if (allocationCriteria?.minDaysGapBetweenJobs) {
      const gapRequired = allocationCriteria.minDaysGapBetweenJobs;

      if (
        allocationCriteria?.currentMonthVisitedDates &&
        allocationCriteria.currentMonthVisitedDates.length > 0
      ) {
        const visitedDates = allocationCriteria.currentMonthVisitedDates;

        for (let visit of visitedDates) {
          const visitDate = dayjs(visit);

          const startBlockedDate = visitDate.subtract(gapRequired, "day");
          const endBlockedDate = visitDate.add(gapRequired, "day");

          if (
            (date.isAfter(startBlockedDate, "day") &&
              date.isBefore(endBlockedDate, "day")) ||
            date.isSame(startBlockedDate, "day") ||
            date.isSame(endBlockedDate, "day") ||
            date.isSame(visitDate, "day") // include exact visit date
          ) {
            return true;
          }
        }
      }

      // 🔹 2. Else fallback to single date
      else if (allocationCriteria?.lastJobVisitedDate) {
        const lastVisitDate = dayjs(allocationCriteria.lastJobVisitedDate);

        const startBlockedDate = lastVisitDate.subtract(gapRequired, "day");
        const endBlockedDate = lastVisitDate.add(gapRequired, "day");

        if (
          (date.isAfter(startBlockedDate, "day") &&
            date.isBefore(endBlockedDate, "day")) ||
          date.isSame(startBlockedDate, "day") ||
          date.isSame(endBlockedDate, "day") ||
          date.isSame(lastVisitDate, "day")
        ) {
          return true;
        }
      }
    }
    // 🔹 Block dates between venueOpenMinus7Days and venueClosePlus3Days
    if (
      allocationCriteria?.venueOpenMinus7Days &&
      allocationCriteria?.venueClosePlus3Days
    ) {
      const date1 = dayjs(allocationCriteria.venueOpenMinus7Days);
      const date2 = dayjs(allocationCriteria.venueClosePlus3Days);

      if (!date1.isValid() || !date2.isValid()) {
        console.log("Invalid date");
        return false;
      }

      const start = date1.isBefore(date2) ? date1 : date2;
      const end = date1.isBefore(date2) ? date2 : date1;

      if (
        (date.isAfter(start, "day") && date.isBefore(end, "day")) ||
        date.isSame(start, "day") ||
        date.isSame(end, "day")
      ) {
        return true;
      }
    }
  };
  useEffect(() => {
    if (
      selectedId !== null &&
      totalallocation?.data[selectedId]?.selectedVisitDate
    ) {
      formik.setFieldValue(
        "selectedVisitDate",
        dayjs(totalallocation?.data[selectedId].selectedVisitDate).format(
          "YYYY-MM-DD"
        )
      );
      totalallocation?.data[selectedId].allocationId.visitTimeInformation.split(',').includes(totalallocation?.data[selectedId].selectedVisitTime.visitTimeId) &&
        (formik.setFieldValue(
          "selectedVisitTime",
          totalallocation?.data[selectedId].selectedVisitTime.visitTimeId
        ));

      formik.setFieldValue(
        "appliedAllocationId",
        totalallocation?.data[selectedId].appliedAllocationId
      );
    }
  }, [totalallocation, selectedId, RequestNewTime]);

  const initialValues: FormValues = {
    selectedVisitDate: "",
    selectedVisitTime: "",
    appliedAllocationId: "",
  };
  const validationSchema = Yup.object().shape({
    selectedVisitDate: Yup.string()
      .required("Visit date is required"),

    selectedVisitTime: Yup.string()
      .required("Visit time is required"),

    appliedAllocationId: Yup.string()
      .required("Allocation is required"),
  });

  const onSubmit = async (values: FormValues) => {
    const reqnewtime = {
      appliedAllocationId: formik.values.appliedAllocationId,
      requestedNewVisitDate: formik.values.selectedVisitDate,
      requestedNewVisitTime: formik.values.selectedVisitTime,
    };
    try {
      const response =
        position === "applied"
          ? await UpdateDateTime(values)
          : await ApiRequestNewDateTime(reqnewtime);
      setformsubmitted(true);
      toast.success(response.message);
      // handleRequestNewTimeClose()

    } catch (error: any) {
      toast.error(error.message);
    }
    finally {
      setRequestNewTime(false);
    }
  };
  const formik = useFormik({
    initialValues,
    validationSchema,
    validateOnChange: true, // Ensures validation only happens on blur or submit
    validateOnBlur: false,
    onSubmit,
  });

  const createReport = async (
    allocationId: any,
    appliedAllocationId: any,
    isReportCreated: any,
    clientGroup?: any
  ) => {
    const isConfirm = window.confirm(`You are creating or updating report for ${totalallocation?.data[selectedId].allocationId?.venueId?.venueName} (${totalallocation?.data[selectedId].allocationId?.clientEntityId?.entityName})`)
    if (isConfirm) {
      if (!isReportCreated) {
        const data = {
          allocationId: allocationId,
          appliedAllocationId: appliedAllocationId,
          createdBy: userData.userId,
        };
        try {
          const response = await ApiCallCreateReport(data, clientGroup);
          if (response.status) {
            navigate(`createOrEditScoreCard`, {
              state: { clientGroup: clientGroup, allocationId: allocationId },
            });
          }
        } catch (error: any) {
          const message =
            error?.response?.data?.message || // API error message
            error?.message ||                 // JS error message
            String(error);
          toast.error(message)
          console.error("Error fetching visit times:", error);
        }
      } else {
        navigate(`createOrEditScoreCard`, {
          state: { clientGroup: clientGroup, allocationId: allocationId },
        });
      }
    }
  };
  const CancelJob = async (selectedId: number | string) => {
    if (totalallocation.data[selectedId]?.bundleId?.bundleId || totalallocation.data[selectedId]?.withoutVenueBundleAllocationId?.withoutVenueBundleAllocationId) {
      const confrim = window.confirm("This task is included in bundle do you want to cancel all bundle tasks")
      if (confrim) {
        const data = position === "applied" ? {
          isBundle: true,
          ...(totalallocation.data[selectedId]?.withoutVenueBundleAllocationId?.withoutVenueBundleAllocationId
            ? {
              withoutVenueBundleAllocationId:
                totalallocation.data[selectedId]?.withoutVenueBundleAllocationId
                  ?.withoutVenueBundleAllocationId,
            }
            : {
              bundleId:
                totalallocation.data[selectedId]?.bundleId?.bundleId,
            }),
          cancelReason: CancelReason === "Other" ? CancelReason2 : CancelReason,
        } : {
          bundleId: totalallocation.data[selectedId]?.bundleId?.bundleId ?? totalallocation.data[selectedId].withoutVenueBundleAllocationId?.withoutVenueBundleAllocationId,
          userId: userData.userId,
          isWithoutVenueBundleId: totalallocation.data[selectedId]?.withoutVenueBundleAllocationId?.withoutVenueBundleAllocationId ? true : false,
          cancelReason: CancelReason === "Other" ? CancelReason2 : CancelReason,
          ignoreCancellationCriteria: true
        };
        try {
          if (CancelReason.length > 0 && data.cancelReason.length > 0) {
            const response = position === 'applied' ? await ApiCancelAppliedAllocation(data) : await ApiCancelBundle(data);
            setOpenCancel(false);
            toast.success(response.message);
            setisdelete(true);
            fetchAppliedAllocations()

          }
        } catch (error: any) {
          toast.error(error.message);
        }
      }
      else {
        return;
      }
    }
    else {
      const data = position === "applied" ? {
        appliedAllocationId: totalallocation.data[selectedId].appliedAllocationId,
        allocationId: totalallocation.data[selectedId].allocationId.allocationId,
        cancelReason: CancelReason === "Other" ? CancelReason2 : CancelReason,
      } : {
        appliedAllocationId: totalallocation.data[selectedId].appliedAllocationId,
        allocationId: totalallocation.data[selectedId].allocationId.allocationId,
        userId: userData.userId,
        cancelReason: CancelReason === "Other" ? CancelReason2 : CancelReason,
        ignoreCancellationCriteria: false
      };

      try {
        if (CancelReason.length > 0 && data.cancelReason.length > 0) {

          const response = position === "applied" ? await ApiCancelAppliedAllocation(data) : await ApiCancelJob(data);
          setOpenCancel(false);
          toast.success(response.message);
          setisdelete(true);
          fetchAppliedAllocations()

        }
      } catch (error: any) {
        toast.error(error.message);
      }
    }
  };
  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string
  ) => {
    if (newAlignment !== null) {
      setposition(newAlignment);
    }
  };

  useEffect(() => {
    const open_calanderTask = () => {
      //  setposition("approved")
      const index =
        totalallocation &&
        totalallocation?.data?.findIndex(
          (item: any) => item.appliedAllocationId == selectedtaskId
        );
      scrollToCard(index)
      index > 0 && setSelectedId(index);
      setisReload(true)
    };
    open_calanderTask();
  }, [taskId, selectedtaskId, totalallocation]);



  const handleCheckAction = async (
    type: "checkIn" | "checkOut",
    allocationId: number,
    appliedAllocationId: number,
    clientGroup: any,
    isReportCreated: boolean
  ) => {
    if (!isReportCreated) {
      const data = {
        allocationId,
        appliedAllocationId,
        createdBy: userData.userId,
      };
      try {
        const response = await ApiCallCreateReport(data, clientGroup);
        await fetchAppliedAllocations();
      } catch (error) {
        console.error("Error creating report:", error);
      }
    }

    // const confirmationMessage =
    //   type === "checkIn"
    //     ? "Are you sure you want to check in?"
    //     : "Are you sure you want to check out?";

    // const userConfirmed = window.confirm(confirmationMessage);
    // if (!userConfirmed) return;

    if (!navigator.geolocation) {
      console.error("Geolocation is not supported by your browser");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        // const { latitude, longitude } = {};
        const params = {
          jobMonth: selectedDate?.month() + 1,
          jobYear: selectedDate?.year(),
          userId: userData.userId,
        };

        try {
          const updatedAllocations = await appliedAllocations(params);
          setAllocation(updatedAllocations);
          // Proceed with check-in/check-out *after* updated allocations are fetched
          const payload = {
            type,
            shopperLatitude: position.coords.latitude,
            shopperLongitude: position.coords.longitude,
            allocationId,
          };
          // console.log("Send Data", payload)
          const response = await ApiCheckInCheckOutShopper(payload, totalallocation?.data[selectedId].allocationId.allocationClientGroup);
          toast.success(response.message);
          if (response.status && type === 'checkIn') {
            navigate(`createOrEditScoreCard`, {
              state: { clientGroup: clientGroup, allocationId: allocationId },
            });
            // navigate(`createOrEditScoreCard/${allocationId}`, {
            //   state: { clientGroup: clientGroup },
            // });
          }
          // Optionally refetch allocations again after API call, if needed
          const refreshedAllocations = await appliedAllocations(params);
          setAllocation(refreshedAllocations);
        } catch (error) {
          toast.error(`${type} failed: ${error}`);
        }
      },
      (error) => {
        console.error("Error getting location:", error);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
    // navigator.geolocation.getCurrentPosition(
    //   async (position) => {
    //     const params = {
    //       jobMonth: selectedDate?.month() + 1,
    //       jobYear: selectedDate?.year(),
    //       userId: userData.userId,
    //     };

    //     try {
    //       const updatedAllocations = await appliedAllocations(params);
    //       setAllocation(updatedAllocations);

    //       const payload = {
    //         type,
    //         shopperLatitude: position.coords.latitude,
    //         shopperLongitude: position.coords.longitude,
    //         allocationId,
    //       };

    //       console.log("GPS Accuracy:", position.coords.accuracy, "meters");
    //       console.log("Coordinates:", payload.shopperLatitude, payload.shopperLongitude);

    //       const response = await ApiCheckInCheckOutShopper(
    //         payload,
    //         totalallocation?.data[selectedId].allocationId.allocationClientGroup
    //       );

    //       toast.success(response.message);

    //       if (response.status && type === 'checkIn') {
    //         navigate(`createOrEditScoreCard/${allocationId}`, {
    //           state: { clientGroup: clientGroup },
    //         });
    //       }

    //       const refreshedAllocations = await appliedAllocations(params);
    //       setAllocation(refreshedAllocations);
    //     } catch (error) {
    //       toast.error(`${type} failed: ${error}`);
    //     }
    //   },
    //   (error) => {
    //     console.error("Geolocation error:", error.code, error.message);

    //     // Provide user-friendly error messages
    //     switch (error.code) {
    //       case error.PERMISSION_DENIED:
    //         toast.error("Location permission denied. Please enable location access.");
    //         break;
    //       case error.POSITION_UNAVAILABLE:
    //         toast.error("Location information unavailable.");
    //         break;
    //       case error.TIMEOUT:
    //         toast.error("Location request timed out. Please try again.");
    //         break;
    //     }
    //   },
    //   {
    //     enableHighAccuracy: true,
    //     timeout: 15000,  // Increased timeout
    //     maximumAge: 0,   // Don't use cached position
    //   }
    // );
  };

  const allocationLogo = (allocationclientGroupName: string) => {

    switch (allocationclientGroupName) {
      case "BLOOMS":
        return BLOOMS
        break;
      case "ALDI":
        return ALDI
        break;
      case "MM":
        return MM
        break;

      default:
        return MM
        break;
    }
  }

  const approvebyShopper = async () => {
    const data = `?appliedAllocationId=${totalallocation?.data[selectedId].appliedAllocationId}`

    try {
      const res = await ApiFinalAcceptedByShopper(data)
      setisshopperconfirm(false);
      fetchAppliedAllocations()
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        String(error);
      toast.error(message)
    }
  }

  const handlegetvenuelist = async () => {
    setshowselectvenue(true)
    try {
      const data = `?month=${selectedDate?.month() + 1}&year=${selectedDate?.year()}&clientEntityId=${totalallocation?.data[selectedId]?.allocationId?.clientEntityId?.clientEntityId}`
      const res = await ApiGetVenueForTransport(data)
      if (res.data) {
        // setselectvenuelist(res?.data?.map((item: any) => ({
        //   venueId: item?.venueId,
        //   venueName: item?.venueName
        // })))
         setselectvenuelist(res?.data?.filter((item:any)=>item?.isActive)?.map((item: any) => ({
          venueId: item?.venueId,
          venueName: item?.venueName
        })))
      }
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        String(error);
      toast.error(message)
    }
  }
  const handleselectedvenue = async () => {
    const isfinal = window.confirm("Do you want to add selected venue")

    setshowselectvenue(false)
    if (isfinal) {
      try {
        const data = {
          "allocationId": totalallocation?.data[selectedId].allocationId.allocationId,
          "venueId": selectedVenueforTransport,
          "updatedBy": parseInt(userData?.userId)
        }
        const res = await ApiSelectVenueForTransport(data)
        if (res.status) {
          await setshowselectvenue(false)
          fetchAppliedAllocations()
          setselectedtaskId(totalallocation?.data[selectedId].allocationId.allocationId)

        }
      } catch (error: any) {
        const message =
          error?.response?.data?.message ||
          error?.message ||
          String(error);
        toast.error(message)
      }
    }
    else {
      setshowselectvenue(false)
    }

  }

  useEffect(() => {
    selectvenuelist?.length > 0 && setselectedVenueforTransport(selectvenuelist[0]?.venueId)
  }, [selectvenuelist])

  const handleDeleteAppliedTask = async (appliedallocationId: string | number) => {
    const confirm = window.confirm("Are you sure you want to cancel this application ?")
    if (confirm) {
      try {
        const data = `?appliedAllocationId=${appliedallocationId}`
        const res = await ApiDeleteAppliedAllocation(data)
        if (res.status || res.success) {
          fetchAppliedAllocations()
        }
      } catch (error: any) {
        toast.error(error.message)
      }
    }
    else {
      return
    }
  }


  const getBrief = async (venueId: string, clientEntity: string) => {
    try {
      const data = `?venueId=${venueId}&clientEntityId=${clientEntity}`
      const res = await ApiGetNewBrief(data)
      if (res?.status || res?.success) {
        setNewBrief(res)
        if (res?.isNewStructureResponse) {
          setOpenNewBriefReadDialog(true)
        }
        else {
          setOpenDialog(true)
        }
      }
    } catch (error: any) {
      toast.error(error?.message || "Something went wrong")
    }
  }

  const isWeekend = (date: string | Date | undefined | null) => {
    if (!date) return false;

    const day = dayjs(date).day(); // 0 = Sunday, 6 = Saturday
    return day === 0 || day === 6;
  };

  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  const handleOpenQuiz = async (clientEntityId: string, venueId: string, isQuizRequired = tempallocationCriteria?.isQuizRequired) => {
    setSelectedOptions([])
    // console.log("ALlocationsFro HandleOpenQuiz", clientEntityId)
    const data = `?clientEntityId=${clientEntityId}&venueId=${venueId}`
    const response = await ApiGetQuiz(data)
    // setQuizList(response.data)
    setQuizType(response?.quizType)
    setQuizList(shuffleArray(response.data))
    // allocationCriteria && allocationCriteria?.isQuizRequired ? setOpenBriefDialog(true) : toast.success("Quiz is not required")
    if (isQuizRequired) {
      setTimeout(() => {
        getBrief(venueId, clientEntityId)

      }, 100);
      // if (allocationCriteria?.isNewBriefSetup) {
      //   setOpenNewBriefReadDialog(true)
      // }
    }
    else {
      toast.error("Someting went wrong")
    }
  }


  const handleCheckQuizandCreateReport = async () => {
    try {
      if (IsQuizSubmitted) {
        const data = {
          userId: userData?.userId,
          type: quizType,
          ...(quizType === "venue"
            ? {
              venueId: totalallocation?.data?.[tempAllocation]?.allocationId?.venueId?.venueId,
            }
            : {
              clientEntityId:
                totalallocation?.data?.[tempAllocation]?.allocationId?.venueId?.clientEntityId?.clientEntityId,
            }),
          //  quizType == "venue" ? venueId:totalallocation?.data[selectedId]?.venueId?.venueId : clientEntityId: totalallocation?.data[selectedId]?.venueId?.clientEntityId?.clientEntityId
        }
        await ApiSubmitQuiz(data)
        setOpenNewBriefReadDialog(false)
        setIsQuizSubmitted(false)
        if (IsNeedtoCreateReport) {
          await createReport(
            totalallocation.data[selectedId]?.allocationId
              ?.allocationId,
            totalallocation.data[selectedId]
              ?.appliedAllocationId,
            totalallocation.data[selectedId]?.allocationId
              .isReportCreated,
            totalallocation.data[selectedId]?.allocationId
              .allocationClientGroup
          )
        }
        else {
          await fetchAllocationCriteria(totalallocation?.data[tempAllocation]?.allocationId, totalallocation?.data[tempAllocation]?.userId?.userId, totalallocation?.data[tempAllocation]?.selectedVisitDate?.split(" ")[0])
        }
      }
    } catch (error) {

    }
  }
  return (
    <Box width="100%" height='100%' overflow='hidden' maxHeight={{ xs: "100vh", lg: "calc(100vh - 70px)" }} className="mytask">
      <Box
        // height="100%"
        bgcolor={{ xs: '#ADB7923A', lg: 'transparent' }}
        position='sticky'
        top={0}

        className="justify-content-between flex-column-reverse flex-md-row mb-2"
        display={{ xs: selectedId !== null ? "none" : "flex", sm: "flex" }}
      >
        <Box p={{ xs: 0, lg: 3 }} className="col-lg-4 col-md-6 col-sm-12  pb-lg-0 mb-0">
          <ToggleButtonGroup
            className="row w-100  phone-menue phone-menue2 m-0 px-0 mx-auto"
            exclusive

            value={position}
            onChange={handleChange}
          >
            <ToggleButton className="py-2 col-4" value="approved">
              <Typography className="fs-18 fw-bold">
                To Do
              </Typography>
            </ToggleButton>
            <ToggleButton className="py-2  col-4" value="applied">
              <Typography className="fs-18 fw-bold">
                Applied
              </Typography>
            </ToggleButton>
            <ToggleButton className="py-2 col-4" value="completed">
              <Typography className="fs-18 fw-bold">
                Completed
              </Typography>
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>

        <Box className="col-12 px-2 mx-md-0 col-md-6 col-xl-5 col-xxl-4 col-lg-3 p-0 p-md-3 pt-0 pb-lg-0 mb-0">
          <Box gap={2} className="d-flex px-sm-2 px-md-0 mt-3 mt-md-0 w-100 align-items-center justify-content-end">

            <Box flex={1}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box
                  display="flex"
                  alignItems="center"
                  className=" col-12 ms-auto  d-flex align-items-center justify-content-between"
                >
                  {/* Previous Month Button */}
                  <IconButton
                    onClick={handlePrevMonth}
                    className="d-none d-lg-block"
                  >
                    <KeyboardArrowLeft />
                  </IconButton>

                  {/* Month & Year Selector */}
                  <DatePicker
                    className="w-100 fs-16"
                    views={["year", "month"]}
                    value={selectedDate}
                    onChange={(date) => {
                      if (!date) return;
                      setDateFromCalnder(null);
                      dispatch(setSelectedMonth(date.toISOString()));
                    }}
                    renderInput={(params) => (
                      <TextField {...params} variant="standard" />
                    )}

                    sx={{

                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                        // maxWidth:'50%',
                      },
                      "& .MuiOutlinedInput-input": {
                        // maxWidth:'70%',
                        // fontSize: { xs: "16px", sm:"18px" }
                      },
                      "& .MuiIconButton-root": {
                        margin: "0px",
                        padding: "0px",
                        color: "#7C9FB2",
                      },
                      "& .MuiSvgIcon-root": {
                        fontSize: { xs: "32px", md: "20px" },
                        paddingRight: 0
                      },

                      "& .MuiOutlinedInput-root": {
                        margin: "0px",
                        paddingLeft: "0px",
                        // maxWidth:'190px !important'
                      },
                    }}
                  />

                  <IconButton
                    onClick={handleNextMonth}
                    className="d-none d-md-block"
                  >
                    <KeyboardArrowRight />
                  </IconButton>
                </Box>
              </LocalizationProvider>
            </Box>
            <FormControl className="col-3 bg-main">
              <Select
                value={selectedclientGroup}
                className="fs-16"
                onChange={(e) => { dispatch(setSelectedClientGroupName(e.target.value)) }}
              >
                {globalclientlist?.map((client) => (
                  <MenuItem value={client?.clientGroupName}>{client?.clientGroupName}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Box>
      </Box>
      {totalallocation?.data?.length > 0 ? (
        <Box

          height={{ xs: "calc(100vh - 100px)", lg: "calc(100vh - 70px - 70px)" }}
          className="d-flex flex-column flex-md-row"
          minHeight={{ lg: "calc(100vh - 133px)" }}
          overflow={'auto'}
        >
          <Box
            // maxHeight="100%"
            sx={{ overflow: "auto" }}
            className="col-md-5 col-lg-4 col-12  py-0 px-3 p-lg-3 pt-lg-0"
            height="100%"
            // maxHeight={}
            display={{
              xs: selectedId !== null ? "none" : "block",
              sm: "block",
            }}
            overflow="auto"
            position='relative'
            bgcolor={'white'}
          >
            <Box className="task-group w-100">
              {totalallocation.data.length > 0 && totalallocation.data.map((item, index) => {
                const currentDate = dayjs(item.selectedVisitDate).format("DD MMM YYYY - dddd");
                const prevDate =
                  index > 0
                    ? dayjs(totalallocation.data[index - 1].selectedVisitDate).format("DD MMM YYYY - dddd")
                    : null;

                const showDateHeader = currentDate !== prevDate;

                return (
                  <Box className='w-100'>
                    {showDateHeader && (
                      <Box position={'sticky'} top={0} className='m-0' bgcolor={'white'} zIndex={1}>
                        <Typography width={'fit-content'} className="fs-16 custom-bg mb-2 border-10 fw-bolder text-light  px-3 py-1">{currentDate}</Typography>
                        <hr className="m-0 mb-2" />
                      </Box>)}
                    <Box
                      className={clsx("my-task w-100 p-2 mb-3 ", {
                        "custom-bg animated-box": selectedId === index && !["applied"].includes(position),
                      })}

                      border="1px solid #a3a3a3"
                      key={index}
                      sx={{
                        background: (position === 'applied' && selectedId === index) ? '#adb79218' : 'transparent',
                        border: (position === 'applied' && selectedId === index) ? '2px solid var(--primary-color)' : '1px solid #a3a3a3'
                      }}
                      onClick={() => {
                        selectcard(index);
                      }}
                      ref={(el: any) => (cardRefs.current[index] = el)}
                      borderRadius="10px"
                    >

                      <Box className="d-flex justify-content-between align-items-start">
                        <Box className="d-flex align-items-start gap-2">
                          <Box
                            className="py-2 px-3"
                            borderRadius="10px"
                            bgcolor={"#BF613B"}
                          >
                            <Typography
                              className={"text-white text-center fw-bold  fs-16"}
                              variant="subtitle1"
                              lineHeight="1.5"
                            >
                              {dayjs(item.selectedVisitDate).format("DD")}
                            </Typography>
                            <Typography
                              // variant="subtitle2"
                              className="m-0 p-0 text-white fs-16"
                              lineHeight="1"
                            >
                              {dayjs(item.selectedVisitDate).format("MMM")}
                            </Typography>
                          </Box>
                          <Box>
                            <Box className='d-flex align-items-center mb-2' gap={1}>
                              <Typography
                                // variant="subtitle1"
                                className={clsx("fw-bold m-0 p-0 fs-16", {
                                  "text-white": selectedId === index && !["applied"].includes(position),
                                  "text-dark": selectedId !== index,
                                })}
                              >
                                {item?.allocationId?.venueId?.venueName ?? item?.allocationId?.clientEntityId?.entityName} {item?.allocationId?.differentiateKey ? `(${item?.allocationId?.differentiateKey})` : ''}
                              </Typography>
                              {item?.isNeedToChangeVisitDate && (<IconButton onClick={() => { setisneeddatechange(true) }} className="animated-alert">
                                <ReportProblemOutlined sx={{ fill: 'red !important' }} />
                              </IconButton>
                              )}

                              {position === 'approved' && (() => {
                                const visitDate = new Date(item?.selectedVisitDate).getTime();
                                const now = Date.now();
                                // const within48Hours = now + 48 * 60 * 60 * 1000;
                                const within72Hours = now + 72 * 60 * 60 * 1000;

                                return (visitDate >= now && visitDate <= within72Hours && !item?.isFinalAcceptByShopper) ? (
                                  // <IconButton
                                  //   onClick={() => setisshopperconfirm(true)}
                                  //   className="animated-alert"
                                  // >
                                  //   <ScheduleSendOutlined sx={{ fill: "red !important", fontSize: '32px' }} />
                                  // </IconButton>
                                  <Button
                                    onClick={() => setisshopperconfirm(true)}
                                    // variant="outlined"
                                    className="btn text-light animated-alert2"
                                    sx={{ fontSize: "10px", background: "var(--third-color)" }}
                                  >
                                    Confirm Task
                                    {/* <ScheduleSendOutlined sx={{ fill: "red !important", fontSize: '32px' }} /> */}
                                  </Button>
                                ) : item?.isFinalAcceptByShopper == true ?
                                  // <DoneAll sx={{ fill: "green !important", fontSize: '28px' }} />
                                  <Typography className="fs-14 fw-bold third-text">(Task Confirmed)</Typography>
                                  : null;
                              })()}
                            </Box>
                            <Box className='d-flex align-items-center' gap={1}>
                              <Typography
                                // variant="caption"
                                className="px-3 py-1 fs-12 text-light"
                                borderRadius="5px"
                                bgcolor={"#7C9FB2"}
                              >
                                {item?.allocationId?.venueId?.clientEntityId?.entityTypeId?.entityTypeName}
                              </Typography>
                              {item?.allocationId?.venueId?.regionId?.regionName && item?.allocationId?.allocationClientGroup == "ALDI" && (<Typography
                                // variant="caption"
                                className="px-3 py-1 fs-12 text-light"
                                borderRadius="5px"
                                bgcolor={"#7C9FB2"}
                              >
                                {item?.allocationId?.venueId?.regionId?.regionName}
                              </Typography>
                              )}
                              <Typography>
                                {/* {dayjs(item?.selectedVisitDate).format("YYYY-MM-DD HH:mm")}
                                {dayjs(dayjs().valueOf() + 48 * 60 * 60 * 1000).format("YYYY-MM-DD HH:mm")} */}
                              </Typography>
                              <Avatar
                                src={allocationLogo(item?.allocationId?.allocationClientGroup)}
                                sx={{
                                  backgroundColor: (selectedId === index && position !== 'applied') ? 'white' : 'transparent',
                                  height: "24px",
                                  width: "24px",
                                  img: {
                                    objectFit: "contain", // ensures the full image fits inside
                                  },
                                }}
                              />
                            </Box>
                          </Box>
                        </Box>
                        <Box
                          component="img"
                          // alt="venuelogo"
                          height="30px"
                          className="p-1"
                          bgcolor="white"
                          borderRadius="10px"
                          src={item?.allocationId?.venueId?.logoUrl || imglogo}
                        ></Box>
                      </Box>
                      {position !== 'applied' ? (
                        <>
                          <Box gap={5} className="d-flex my-1 mt-3  justify-content-between align-items-start">
                            {item?.allocationId?.venueId?.clientEntityId?.entityTypeId?.entityTypeName != "Liquor ID" && (<Box>
                              <Typography
                                className={clsx("form-caption  mb-0 pb-0", {
                                  "text-white": selectedId === index && position !== 'applied',
                                  "text-dark": selectedId !== index,
                                })}
                              >
                                <span className="fs-16"> Opening Hours</span>
                              </Typography>
                              <Typography
                                className={clsx("fw-bold fs-16", {
                                  "text-white": selectedId === index && position !== 'applied',
                                  "text-dark": selectedId !== index,
                                })}
                                variant="subtitle1"
                              >
                                {item?.allocationId?.venueId?.tradingHours}
                              </Typography>
                            </Box>)}
                            <Box>
                              <Typography
                                className={clsx("form-caption fs-16 mb-0 pb-0", {
                                  "text-white": selectedId === index && position !== 'applied',
                                  "text-dark": selectedId !== index,
                                })}
                                sx={{ textWrap: "nowrap" }}
                              >
                                Visit Timing
                              </Typography>
                              <Typography
                                className={clsx("fw-bold fs-16 text-start", {
                                  "text-white": selectedId === index && position !== 'applied',
                                  "text-dark": selectedId !== index,
                                })}
                                variant="subtitle1"
                              >
                                {item?.selectedVisitTime?.visitTimeInformation}
                              </Typography>
                            </Box>
                          </Box>
                          <Typography
                            // variant="subtitle1"
                            className={clsx("my-1 fs-16", {
                              "text-white": selectedId === index && position !== 'applied',
                              "text-dark": selectedId !== index,
                            })}
                          >
                            {item?.allocationId?.venueId?.address} {item?.allocationId?.venueId?.city} {item?.allocationId?.venueId?.state} {item?.allocationId?.venueId?.postalCode}
                          </Typography>
                          <Typography
                            className={clsx("my-1 form-caption fs-16", {
                              "text-white": selectedId === index && position !== 'applied',
                              "text-dark": selectedId !== index,
                            })}
                          >
                            {item?.allocationId?.allocationPriceDisplay !== "" ? item?.allocationId?.allocationPriceDisplay : `$${item?.allocationId?.allocationPriceDisplay}`}
                          </Typography>
                          <Divider
                            className="my-3"
                            sx={{
                              borderColor: (selectedId === index && position !== 'applied') ? "#FFFFFF" : "#a3a3a3",
                            }}
                          />
                        </>
                      ) : (
                        <Box className='my-2'>
                          <Box className='d-flex align-items-center justify-content-between gap-1'>
                            <Box>
                              <Typography variant="body1">{item?.selectedVisitTime?.visitTimeInformation}</Typography>
                              <Typography variant="body1">{item?.allocationId?.allocationPriceDisplay !== "" ? item?.allocationId?.allocationPriceDisplay : `$${item?.allocationId?.allocationPriceDisplay}`}</Typography>
                            </Box>
                            <Box className='py-1 px-2 d-flex align-items-center gap-2 mt-1 mb-3' sx={{ border: '1px solid #ADB792', borderRadius: '5px'}}>
                              <AccessTimeOutlined sx={{ fill: "#ADB792 !important", fontSize: "16px" }} />
                              <Typography sx={{ color: "#ADB792", lineHeight: 'normal' }} variant="caption">APPLICATION PENDING</Typography>
                            </Box>
                          </Box>
                          <Box className='p-2 d-flex align-items-center gap-2 mt-1 mb-3' sx={{ border: '1px solid #db2d2d', borderRadius: '5px', background: '#db2d2d1A' }}>
                            <AccessTimeOutlined sx={{ fill: "#db2d2d !important", fontSize: "16px" }} />
                            <Typography sx={{ color: "#db2d2d", lineHeight: 'normal' }} variant="caption">You have applied for this task. It has not been assigned to you.</Typography>
                          </Box>
                        </Box>
                      )}

                      <Box className="d-flex gap-2">
                        <Button
                          variant="outlined"
                          className={clsx("py-1 py-sm-2 fs-16 px-auto transform ", {
                            "text-white button-outlined-selected border-white":
                              selectedId === index && position !== 'applied',
                            "button-secondary-outlined": selectedId !== index || position === 'applied',
                          })}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDialogOpen(item, index);
                          }}
                          fullWidth
                        >
                          Brief
                        </Button>
                        {item?.allocationId?.isTrainingRequired && item?.allocationId?.slotId?.bookingStatusId?.statusName !== "Completed" && (<Button
                          variant="outlined"
                          className={clsx("py-1 py-sm-2 fs-16 px-auto transform ", {
                            "text-white button-outlined-selected border-white":
                              selectedId === index && position !== 'applied',
                            "button-secondary-outlined": selectedId !== index || position === 'applied',
                          })}
                          onClick={() => {
                            handleOpenTrainingDialog(item?.allocationId?.allocationId);
                          }}
                          fullWidth
                        >
                          {item?.allocationId?.slotId?.slotId ? "UpdateTraining Slot" : "Book Training Slot"}
                        </Button>
                        )}
                        <Button
                          variant="contained"
                          className={clsx("py-1 py-sm-2 fs-16 px-auto transform", {
                            "custom-text selected-primary-button bg-light":
                              selectedId === index && position !== 'applied',
                            "button-primary": selectedId !== index || position === 'applied',
                          })}
                          fullWidth
                          onClick={(e) => {
                            e.stopPropagation();
                            // debugger
                            navigate("/dashboard/myTasks/Questions",
                              {
                                state:
                                {
                                  venueId: item?.allocationId?.venueId?.venueId,
                                  clientEntityId: item?.allocationId?.venueId?.clientEntityId?.clientEntityId,
                                  venue: item?.allocationId?.venueId?.venueName,
                                  DateofVisit: new Date(item?.selectedVisitDate).toLocaleDateString("en-GB"),
                                  TimeofVisit: item?.selectedVisitTime?.visitTimeInformation
                                }
                              })
                            localStorage.setItem('ActiveTask', 'Questions')
                          }

                          }
                        >
                          View Questions
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                )
              })}
              {/* {loading && <Loading />} */}
            </Box>
          </Box>
          <Box p={{ xs: 0, lg: 3 }} className="col-md-7 col-lg-8 col-12">
            {selectedId !== null && totalallocation?.data[selectedId] && (
              <>
                <Box
                  className="h-100 d-flex  flex-lg-row flex-column"
                  height='fit-content'
                  borderRadius="10px"
                  border={{ xs: "none", sm: "1px solid #a3a3a3" }}
                >
                  <Box className="d-flex d-md-none py-2 align-items-center justify-content-between" bgcolor={{ xs: "#ADB7922A", lg: "transparent" }}>
                    <Box className='d-flex align-items-center' gap={2}>
                      <IconButton
                        className="justify-content-start d-flex d-md-none"
                        onClick={() => {
                          setSelectedId(null);
                        }}
                      >
                        <KeyboardArrowLeft fontSize="medium" />
                      </IconButton>
                      <Typography fontWeight='bold' className="fs-18">{totalallocation.data[selectedId]?.allocationId
                        ?.venueId?.venueName ?? totalallocation.data[selectedId]?.allocationId?.clientEntityId?.entityName}</Typography>
                    </Box>
                    {position !== 'applied' && (
                      <Box className="col-1">
                        <IconButton
                          aria-label="more"
                          id="long-button"
                          aria-controls={open ? "long-menu" : undefined}
                          aria-expanded={open ? "true" : undefined}
                          aria-haspopup="true"
                          onClick={handlePhoneMenue}
                        >
                          <MoreVert />
                        </IconButton>
                        <Menu
                          id="long-menu"
                          MenuListProps={{
                            "aria-labelledby": "long-button",
                          }}
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleClose}
                        >
                          <MenuItem
                            className="fs-16"
                            disabled={totalallocation?.data[selectedId]?.allocationId.allocationClientGroup === 'TRANSPORT'}
                            sx={{
                              "&.Mui-disabled": {
                                backgroundColor: "grey !important",
                                color: "#0000005A !important",
                              },

                            }}
                            onClick={() => {
                              handleClose("Get Directions");
                              handleOpenGoogleMaps(
                                totalallocation?.data[selectedId]?.allocationId
                                  ?.venueId?.lat,
                                totalallocation?.data[selectedId]?.allocationId
                                  ?.venueId?.long
                              );
                            }}
                          >
                            Get Directions
                          </MenuItem>

                          <MenuItem
                            className="fs-16"
                            onClick={() => {
                              handleClose("Shopper Brief");
                              handleDialogOpen(totalallocation?.data[selectedId], selectedId);
                            }}
                          >
                            Shopper Brief
                          </MenuItem>

                          <MenuItem
                            className="fs-16"
                            onClick={() => {
                              navigate("/dashboard/myTasks/Questionss",
                                {
                                  state:
                                  {
                                    venueId: totalallocation?.data[selectedId]?.allocationId?.venueId?.venueId,
                                    clientEntityId: totalallocation?.data[selectedId]?.allocationId?.venueId?.clientEntityId?.clientEntityId,
                                    venue: totalallocation?.data[selectedId]?.allocationId?.venueId?.venueName,
                                    DateofVisit: new Date(totalallocation?.data[selectedId]?.selectedVisitDate).toLocaleDateString("en-GB"),
                                    TimeofVisit: totalallocation?.data[selectedId]?.selectedVisitTime?.visitTimeInformation
                                  }
                                })
                              localStorage.setItem('ActiveTask', 'Questions')
                              handleClose("View/Print Questions")
                            }

                            }
                          // onClick={() => handleClose("View/Print Questions")}
                          >
                            View/Print Questions
                          </MenuItem>

                          {(totalallocation.data[selectedId].allocationId.reportStatus === 'unc' || totalallocation.data[selectedId].allocationId.reportStatus === null) && (
                            <MenuItem
                              className="fs-16"
                              onClick={() => {
                                handleClose("Request New Time");
                                handleRequestNewTimeOpen();
                              }}

                            >
                              Request New Time
                            </MenuItem>
                          )}
                        </Menu>
                      </Box>
                    )}
                  </Box>
                  <Box className="col-lg-7 col-12 p-3 d-flex flex-column">
                    <Box className="flex-grow-1">
                      <Box className="d-flex justify-content-between align-items-start">
                        <Box className="d-flex gap-2 ">
                          <Box
                            className="p-2 px-3 bg-third"
                            borderRadius="10px"

                          >
                            <Typography
                              className="text-white fs-16 text-center fw-bold"
                              // variant="subtitle1"
                              lineHeight="1.5"
                            >
                              {dayjs(
                                totalallocation.data[selectedId]
                                  .selectedVisitDate
                              ).format("DD")}
                            </Typography>
                            <Typography
                              // variant="subtitle2"
                              className="m-0 p-0 fs-16 text-white"
                              lineHeight="1"
                            >
                              {dayjs(
                                totalallocation.data[selectedId]
                                  .selectedVisitDate
                              ).format("MMM")}
                            </Typography>
                          </Box>
                          <Box>
                            <Box className='d-flex fs-16 align-items-center' gap={1}>
                              <Typography
                                // variant="subtitle1"
                                className="fw-bold m-0 p-0"
                              >
                                {" "}
                                {
                                  totalallocation.data[selectedId].allocationId
                                    ?.venueId?.venueName ?? totalallocation.data[selectedId]?.allocationId?.clientEntityId?.entityName
                                } {totalallocation.data[selectedId]?.allocationId.differentiateKey ? `(${totalallocation.data[selectedId]?.allocationId.differentiateKey})` : ''}
                              </Typography>
                              {totalallocation.data[selectedId]?.isNeedToChangeVisitDate && (
                                <IconButton className="animated-alert" onClick={() => { setisneeddatechange(true) }}>
                                  <ReportProblemOutlined sx={{ fill: 'red !important' }} />
                                </IconButton>
                              )}
                            </Box>
                            <Box className='d-flex align-items-center' gap={1}>
                              <Typography
                                // variant="caption"
                                className="px-3 fs-12 py-1 text-white bg-second"
                                borderRadius="5px"
                              >
                                {
                                  totalallocation.data[selectedId].allocationId
                                    .venueId?.clientEntityId?.entityTypeId?.entityTypeName ?? ""
                                }
                              </Typography>
                              {totalallocation.data[selectedId]?.allocationId
                                .venueId?.regionId?.regionName && totalallocation?.data[selectedId]?.allocationId?.allocationClientGroup == "ALDI" && (<Typography
                                  // variant="caption"
                                  className="px-3 fs-12 py-1 text-white bg-second"
                                  borderRadius="5px"
                                >
                                  {
                                    totalallocation.data[selectedId]?.allocationId
                                      .venueId?.regionId?.regionName
                                  }
                                </Typography>
                                )}
                              <Avatar
                                src={allocationLogo(totalallocation?.data[selectedId]?.allocationId?.allocationClientGroup)}
                                sx={{
                                  backgroundColor: 'transparent',
                                  height: "24px",
                                  width: "24px",
                                  img: {
                                    objectFit: "contain",
                                  },
                                }}
                              />
                            </Box>

                          </Box>
                        </Box>
                        <Box
                          src={
                            totalallocation?.data[selectedId]?.allocationId
                              ?.venueId?.logoUrl || imglogo
                          }
                          component="img"
                          height="30px"
                          className="p-1"
                          bgcolor="white"
                          borderRadius="10px"
                        />
                      </Box>
                      <Box className="my-2">
                        <Typography className="text-grey fs-16">
                          Address
                        </Typography>
                        <Typography fontWeight="bold" className="fs-16">
                          {
                            totalallocation.data[selectedId].allocationId
                              ?.venueId?.address
                          } {totalallocation.data[selectedId].allocationId?.venueId?.city} {totalallocation.data[selectedId].allocationId?.venueId?.state} {totalallocation.data[selectedId].allocationId?.venueId?.postalCode}
                        </Typography>
                      </Box>
                      <Box className="my-2">
                        <Typography className="text-grey fs-16">
                          Website
                        </Typography>
                        <Typography className="fs-16" fontWeight="bold">
                          <a target="__blank" href={totalallocation.data[selectedId].allocationId
                            ?.venueId?.websiteURL}> {
                              totalallocation.data[selectedId].allocationId
                                ?.venueId?.websiteURL
                            }</a>
                        </Typography>
                      </Box>
                      <Box className="my-2 mb-4">
                        <Typography className="text-grey fs-16">
                          Amount
                        </Typography>
                        <Typography

                          className="text-main fs-16"
                        >
                          {
                            totalallocation.data[selectedId].allocationId.allocationPriceDisplay !== "" ? totalallocation.data[selectedId].allocationId.allocationPriceDisplay : `$${totalallocation.data[selectedId].allocationId?.allocationPrice}`
                          }
                        </Typography>
                      </Box>


                      <a className="bg-second px-3 fs-16 py-2 text-light border-10" style={{ textDecoration: "none" }} target="__blank" href={totalallocation.data[selectedId]?.allocationId?.venueId?.sampleReportUrl?.trim()?.length > 0 ? totalallocation.data[selectedId]?.allocationId?.venueId?.sampleReportUrl : totalallocation.data[selectedId]?.allocationId?.venueId?.clientEntityId?.sampleReportUrl}>View Sample Report</a>
                      {(() => {
                        const visitDate = new Date(totalallocation.data[selectedId]?.selectedVisitDate).getTime();
                        const now = Date.now();
                        const within48Hours = now + 48 * 60 * 60 * 1000;

                        return (visitDate >= now && visitDate <= within48Hours && !totalallocation.data[selectedId]?.isFinalAcceptByShopper && position === 'approved') ? (
                          // <IconButton onClick={() => { setisshopperconfirm(true) }}> <ScheduleSendOutlined sx={{ fontSize: "36px", fill: 'red !important' }} /></IconButton>
                          <Button
                            onClick={() => setisshopperconfirm(true)}
                            // variant="outlined"
                            className="btn text-light ms-3 animated-alert2"
                            sx={{ fontSize: "10px", background: "var(--third-color)" }}
                          >
                            Confirm Task
                            {/* <ScheduleSendOutlined sx={{ fill: "red !important", fontSize: '32px' }} /> */}
                          </Button>

                        ) : null;
                      })()}
                      {(totalallocation.data[selectedId]?.allocationId?.isTrainingRequired && totalallocation.data[selectedId]?.allocationId?.slotId) ? (
                        <Box className='mt-5 p-3 w-75 d-flex flex-column align-items-start' sx={{ border: '1px solid black', borderRadius: '10px' }}>
                          <Typography gutterBottom className="text-center">Trainer Name: <span className="fw-bold">{totalallocation.data[selectedId]?.allocationId?.slotId?.availabilityId.adminUserId.firstName}</span> <span className="fw-bold">{totalallocation.data[selectedId]?.allocationId?.slotId?.availabilityId.adminUserId.lastName}</span></Typography>
                          <Typography gutterBottom className="text-center">Training Date: <span className="fw-bold">{dayjs(totalallocation.data[selectedId]?.allocationId?.slotId?.slotStart.replace(" ", "T") + ".000Z").format('DD-MM-YYYY')}</span></Typography>
                          <Typography gutterBottom className="text-center">Training Time: <span className="fw-bold">{dayjs.utc(totalallocation.data[selectedId]?.allocationId?.slotId?.slotStart).local().format('hh:mm A')} - {dayjs.utc(totalallocation.data[selectedId]?.allocationId?.slotId?.slotEnd).local().format("hh:mm A")}</span></Typography>
                          {totalallocation.data[selectedId]?.allocationId?.slotId?.bookingStatusId?.statusName !== "Completed" && <Button
                            variant="contained"
                            fullWidth
                            sx={{ borderRadius: '10px' }}
                            className="py-1 py-sm-2 fs-16 mx-auto px-auto transform text-white bg-second"

                            onClick={() => {
                              handleOpenTrainingDialog(totalallocation.data[selectedId]?.allocationId?.allocationId);
                            }}
                          >
                            {totalallocation.data[selectedId]?.allocationId?.slotId?.slotId ? "Update Training Slot" : "Book Training Slot"}
                          </Button>}
                        </Box>
                      ) : ("")
                      }
                      {(totalallocation.data[selectedId]?.allocationId?.isTrainingRequired && totalallocation.data[selectedId]?.allocationId?.slotId?.bookingStatusId?.statusName !== "Completed" && !totalallocation.data[selectedId]?.allocationId?.slotId) && (
                        <Button
                          variant="contained"
                          fullWidth
                          sx={{ borderRadius: '10px' }}
                          className="py-1 py-sm-2 fs-16 w-75 mt-5 mx-auto px-auto transform text-white bg-second"

                          onClick={() => {
                            handleOpenTrainingDialog(totalallocation.data[selectedId]?.allocationId?.allocationId);
                          }}
                        >
                          {totalallocation.data[selectedId]?.allocationId?.slotId?.slotId ? "Update Training Slot" : "Book Training Slot"}
                        </Button>
                      )
                      }
                    </Box>
                    {position === "applied" &&
                      (
                        <Box className='p-2 d-flex align-items-center gap-2 mt-1 mb-3' sx={{ border: '1px solid #db2d2d', borderRadius: '5px', background: '#db2d2d1A' }}>
                          <AccessTimeOutlined sx={{ fill: "#db2d2d !important", fontSize: "16px" }} />
                          <Typography sx={{ color: "#db2d2d", lineHeight: 'normal' }} variant="caption">You have applied for this task. It has not been assigned to you.</Typography>
                        </Box>
                      )}
                    {(position === "approved" &&
                      !totalallocation.data[selectedId].allocationId
                        .isReportCreated || position === "applied") && (
                        <Link
                          to=""
                          onClick={() => {
                            // position === "applied" ? handleDeleteAppliedTask(totalallocation.data[selectedId]?.appliedAllocationId) : 
                            handleCloseOpen()
                          }}
                          className="router-link fs-16 mt-3"
                        >
                          Do you need to cancel your application?
                        </Link>
                      )}
                  </Box>
                  {/* {window.innerWidth > 767 && (
                    <Divider
                      orientation="vertical"
                      sx={{
                        display: {
                          xs: "none",
                          sm: "block",
                        },
                        borderColor: "#a3a3a3",
                      }}
                    />
                  )} */}

                  <Box overflow={'auto'} className="col-lg-5 flex-grow-1 d-flex flex-column col-12 p-3">
                    <Box className="flex-grow-1 mb-3">
                      <ToggleButtonGroup fullWidth>
                        {totalallocation.data[selectedId].allocationId
                          .venueId?.clientEntityId?.entityTypeId?.entityTypeName != "Liquor ID" && (
                            <ToggleButton value="" disabled>
                              <Box className="text-center">
                                <Typography
                                  // variant="caption"
                                  className="text-grey fs-14"
                                >
                                  Opening Hours
                                </Typography>
                                <Typography
                                  // variant="subtitle2"
                                  className="text-dark fs-14 mt-1"
                                  fontWeight="bold"
                                >
                                  {
                                    totalallocation.data[selectedId].allocationId
                                      ?.venueId?.tradingHours
                                  }
                                </Typography>
                              </Box>
                            </ToggleButton>
                          )}
                        <ToggleButton
                          value=""
                          disabled
                          className="text-center"
                        >
                          <Box className="text-center">
                            <Typography
                              // variant="caption"
                              className="text-grey fs-14"
                            >
                              Selected Timing
                            </Typography>
                            <Typography
                              // variant="subtitle2"
                              className="text-dark fs-14"
                              fontWeight="bold"
                            >
                              {
                                totalallocation.data[selectedId]
                                  .selectedVisitTime.visitTimeInformation
                              }
                            </Typography>
                          </Box>
                        </ToggleButton>
                      </ToggleButtonGroup>

                    </Box>


                    {/* <Button onClick={()=>{setisshopperconfirm(true)}} sx={{width:'fit-content'}} className="button-primary px-4 mx-auto  my-3 py-2">Confirm Attendance</Button> */}

                    <Box>

                      <Box className="d-none d-md-flex flex-column flex-wrap gap-2">

                        {position !== 'applied' && (
                          <>
                            <Box className="d-flex manage-width  gap-2 d-md-flex">
                              <Button
                                variant="contained"
                                disabled={totalallocation?.data[selectedId]?.allocationId.allocationClientGroup === 'TRANSPORT'}
                                // className=""
                                className={clsx("py-3 flex-column w-49 d-flex", {
                                  "bg-second ": totalallocation?.data[selectedId]?.allocationId.allocationClientGroup !== 'TRANSPORT',
                                })}

                                onClick={() => {
                                  handleOpenGoogleMaps(
                                    totalallocation?.data[selectedId].allocationId
                                      ?.venueId?.lat,
                                    totalallocation?.data[selectedId].allocationId
                                      ?.venueId?.long
                                  );
                                }}
                                sx={{
                                  fontSize: "14px !important", gap: 1, borderRadius: '10px',
                                  "&.Mui-disabled": {
                                    backgroundColor: "lightgrey !important",
                                    color: "0000005A !important",
                                  },

                                }}
                              >
                                <Box
                                  component="img"
                                  className="col-2"
                                  src={direction}

                                ></Box>
                                Get Directions
                              </Button>
                              <Button
                                variant="contained"
                                className="w-49 d-flex bg-second flex-column"
                                onClick={() => {
                                  // handleDialogOpen();
                                  handleDialogOpen(totalallocation?.data[selectedId], selectedId);
                                }}
                                sx={{ fontSize: "14px !important", gap: 1, borderRadius: '10px' }}
                              >
                                <Box
                                  component="img"
                                  className="col-2"
                                  src={brief}
                                ></Box>
                                Shopper Brief
                              </Button>
                            </Box>
                            <Box className="d-flex manage-width gap-2 d-md-flex">
                              <Button
                                variant="contained"
                                className="w-49 d-flex py-3 flex-column bg-second"
                                sx={{ fontSize: "14px !important", gap: 1, borderRadius: '10px' }}
                                onClick={() => {
                                  navigate("/dashboard/myTasks/Questions",
                                    {
                                      state:
                                      {
                                        venueId: totalallocation?.data[selectedId].allocationId?.venueId?.venueId,
                                        clientEntityId: totalallocation?.data[selectedId].allocationId?.venueId?.clientEntityId?.clientEntityId,
                                        venue: totalallocation?.data[selectedId].allocationId?.venueId?.venueName,
                                        DateofVisit: new Date(totalallocation?.data[selectedId].selectedVisitDate).toLocaleDateString("en-GB"),
                                        TimeofVisit: totalallocation?.data[selectedId].selectedVisitTime.visitTimeInformation
                                      }
                                    })
                                  localStorage.setItem('ActiveTask', 'Questions')
                                  handleClose("View/Print Questions")
                                }
                                }
                              >
                                <Box
                                  component="img"
                                  className="col-2"
                                  src={print}



                                ></Box>
                                View/Print Questions
                              </Button>
                              <Button
                                variant="contained"
                                onClick={() => {
                                  handleRequestNewTimeOpen();
                                }}
                                disabled={totalallocation.data[selectedId].allocationId
                                  .reportStatus !== 'unc' && totalallocation.data[selectedId].allocationId
                                    .reportStatus !== null}
                                className={clsx("w-49 d-flex flex-column ", {
                                  "bg-second ": position !== 'completed',
                                })}
                                sx={{
                                  fontSize: "14px !important", gap: 1, borderRadius: '10px',
                                  "&.Mui-disabled": {
                                    backgroundColor: "lightgrey !important",
                                    color: "#0000005A !important",
                                  },
                                }}
                              >
                                <Box
                                  component="img"
                                  className="col-2 whitespace-wrap"
                                  src={calender}
                                ></Box>
                                Request New Time
                              </Button>
                            </Box>
                          </>)}
                      </Box>

                      {position === 'approved' &&
                        (
                          <>
                            <Divider
                              className="my-3 d-md-block d-none"
                              sx={{ borderColor: "#a3a3a3" }}
                            />
                            {!totalallocation.data[selectedId].allocationId?.venueId && (<Button
                              variant="outlined"
                              className="button-outlined transform py-3 mb-2 w-100 px-auto"
                              sx={{
                                fontSize: "14px !important", borderRadius: '10px',
                                "&.Mui-disabled": {
                                  backgroundColor: "lightgrey !important",
                                  color: "#0000005A !important",
                                },
                              }}
                              onClick={() => { handlegetvenuelist() }}
                            > Select Venue</Button>
                            )}

                            <Box className="d-flex gap-2">
                              {(!totalallocation.data[selectedId]?.allocationId?.isTrainingRequired || totalallocation.data[selectedId]?.allocationId?.slotId?.slotId) &&
                                (
                                  <>
                                    <Button
                                      variant="contained"
                                      className="bg-third py-1 px-auto"
                                      sx={{
                                        fontSize: "14px !important", borderRadius: '10px',
                                        "&.Mui-disabled": {
                                          backgroundColor: "lightgrey !important",
                                          color: "#0000005A !important",
                                        },

                                      }}
                                      disabled={totalallocation.data[selectedId].allocationId
                                        .isReportCreated && totalallocation.data[selectedId].allocationId.reportStatus !== 'unc'}
                                      onClick={async () => {
                                        // if(totalallocation.data[selectedId]?.isNeedToChangeVisitDate){
                                        //   alert("You can not create report with this date please change your inspection date to create report")
                                        //   return;
                                        // }
                                        // totalallocation.data[selectedId].allocationId?.venueId ?
                                        if (tempallocationCriteria && tempallocationCriteria?.isQuizRequired) {
                                          // await handleOpenQuiz(totalallocation?.data[selectedId]?.allocationId?.venueId?.clientEntityId?.clientEntityId, totalallocation?.data[selectedId]?.allocationId?.venueId?.venueId)
                                          setIsNeedtoCreateReport(true)
                                          handleDialogOpen(totalallocation?.data[selectedId], selectedId)
                                        }
                                        else {
                                          createReport(
                                            totalallocation.data[selectedId].allocationId
                                              .allocationId,
                                            totalallocation.data[selectedId]
                                              .appliedAllocationId,
                                            totalallocation.data[selectedId].allocationId
                                              .isReportCreated,
                                            totalallocation.data[selectedId].allocationId
                                              .allocationClientGroup
                                          )
                                        }
                                      }
                                        // :
                                        // handlegetvenuelist()
                                      }
                                      fullWidth
                                    >

                                      {allocationCriteria?.isQuizRequired ? "Take Quiz" : totalallocation.data[selectedId].allocationId.reportStatus !== 'unc' && totalallocation.data[selectedId].allocationId.reportStatus !== null ? "Submitted" :
                                        totalallocation.data[selectedId].allocationId
                                          .isReportCreated
                                          ? "Edit Report"
                                          : "Create Report"}
                                    </Button>
                                    <Button
                                      variant="contained"

                                      className="custom-bg text-dark py-2 py-sm-3 px-auto"
                                      fullWidth
                                      disabled={(totalallocation.data[selectedId].allocationId.checkOutDateTime ? true : false) || (totalallocation.data[selectedId].allocationId
                                        .isReportCreated && totalallocation.data[selectedId].allocationId.reportStatus !== 'unc')}
                                      onClick={() => {
                                        //  if(totalallocation.data[selectedId]?.isNeedToChangeVisitDate){
                                        //   alert("You can not create report with this date please change your inspection date to create report")
                                        //   return;
                                        // }
                                        handleCheckAction(
                                          totalallocation.data[selectedId].allocationId
                                            .checkInDateTime !== null
                                            ? "checkOut"
                                            : "checkIn",

                                          totalallocation.data[selectedId].allocationId
                                            .allocationId,
                                          totalallocation.data[selectedId]
                                            .appliedAllocationId,
                                          totalallocation.data[selectedId].allocationId
                                            .allocationClientGroup,
                                          totalallocation.data[selectedId].allocationId
                                            .isReportCreated
                                        );
                                      }}
                                      sx={{
                                        fontSize: "14px !important",
                                        borderRadius: '10px',
                                        backgroundColor: totalallocation.data[selectedId].allocationId.checkOutDateTime ? 'grey !important' : '',
                                        "&.Mui-disabled": {
                                          backgroundColor: "lightgrey !important",
                                          color: "#0000005A !important",
                                        },

                                      }}
                                    >
                                      {totalallocation.data[selectedId].allocationId
                                        .checkInDateTime
                                        ? "Check-Out"
                                        : "Check-In"}
                                    </Button>
                                  </>

                                )
                              }

                            </Box> </>)}


                    </Box>
                  </Box>

                  {/* {position !== "applied" ?
                    (
                      <Box overflow={'auto'} className="col-md-5 flex-grow-1 d-flex flex-column col-12 p-3">
                        <Box className="flex-grow-1 mb-3">
                          <ToggleButtonGroup fullWidth>
                            <ToggleButton value="" disabled>
                              <Box className="text-center">
                                <Typography
                                  variant="caption"
                                  className="text-grey"
                                >
                                  Opening Hours
                                </Typography>
                                <Typography
                                  variant="subtitle2"
                                  className="text-dark"
                                  fontWeight="bold"
                                >
                                  {
                                    totalallocation.data[selectedId].allocationId
                                      ?.venueId?.tradingHours
                                  }
                                </Typography>
                              </Box>
                            </ToggleButton>
                            <ToggleButton
                              value=""
                              disabled
                              className="text-center"
                            >
                              <Box className="text-center">
                                <Typography
                                  variant="caption"
                                  className="text-grey"
                                >
                                  Selected Timing
                                </Typography>
                                <Typography
                                  variant="subtitle2"
                                  className="text-dark"
                                  fontWeight="bold"
                                >
                                  {
                                    totalallocation.data[selectedId]
                                      .selectedVisitTime.visitTimeInformation
                                  }
                                </Typography>
                              </Box>
                            </ToggleButton>
                          </ToggleButtonGroup>
                        </Box>

                        <Box>
                          <Box className="d-none d-md-flex flex-column flex-wrap gap-2">
                            {(() => {
                              const visitDate = new Date(totalallocation.data[selectedId]?.selectedVisitDate).getTime();
                              const now = Date.now();
                              const within48Hours = now + 48 * 60 * 60 * 1000;

                              return (visitDate >= now && visitDate <= within48Hours && !totalallocation.data[selectedId]?.isFinalAcceptByShopper) ? (
                                <Box className="d-flex justify-content-center manage-width gap-2 d-md-flex">
                                  <Button
                                    variant="contained"
                                    className={"py-2 flex-column w-49 d-flex bg-second"}

                                    onClick={() => { setisshopperconfirm(true) }}
                                    sx={{
                                      fontSize: "14px !important", gap: 1, borderRadius: '10px',
                                    }}
                                  >
                                    <ScheduleSendOutlined sx={{ fontSize: "36px", fill: 'white !important' }} />
                                    Confirm Attendance
                                  </Button>
                                </Box>
                              ) : null;
                            })()}

                            <Box className="d-flex manage-width  gap-2 d-md-flex">
                              <Button
                                variant="contained"
                                disabled={totalallocation?.data[selectedId]?.allocationId.allocationClientGroup === 'TRANSPORT'}
                                // className=""
                                className={clsx("py-3 flex-column w-49 d-flex", {
                                  "bg-second ": totalallocation?.data[selectedId]?.allocationId.allocationClientGroup !== 'TRANSPORT',
                                })}

                                onClick={() => {
                                  handleOpenGoogleMaps(
                                    totalallocation?.data[selectedId].allocationId
                                      ?.venueId?.lat,
                                    totalallocation?.data[selectedId].allocationId
                                      ?.venueId?.long
                                  );
                                }}
                                sx={{
                                  fontSize: "14px !important", gap: 1, borderRadius: '10px',
                                  "&.Mui-disabled": {
                                    backgroundColor: "lightgrey !important",
                                    color: "0000005A !important",
                                  },

                                }}
                              >
                                <Box
                                  component="img"
                                  className="col-2"
                                  src={direction}

                                ></Box>
                                Get Directions
                              </Button>
                              <Button
                                variant="contained"
                                className="w-49 d-flex bg-second flex-column"
                                onClick={() => {
                                  handleDialogOpen();
                                }}
                                sx={{ fontSize: "14px !important", gap: 1, borderRadius: '10px' }}
                              >
                                <Box
                                  component="img"
                                  className="col-2"
                                  src={brief}
                                ></Box>
                                Shopper Brief
                              </Button>
                            </Box>
                            <Box className="d-flex manage-width gap-2 d-md-flex">
                              <Button
                                variant="contained"
                                className="w-49 d-flex py-3 flex-column bg-second"
                                sx={{ fontSize: "14px !important", gap: 1, borderRadius: '10px' }}
                                onClick={() => {
                                  navigate("/dashboard/myTasks/Questions",
                                    {
                                      state:
                                      {
                                        venueId: totalallocation?.data[selectedId].allocationId?.venueId?.venueId,
                                        clientEntityId: totalallocation?.data[selectedId].allocationId?.venueId?.clientEntityId?.clientEntityId,
                                        venue: totalallocation?.data[selectedId].allocationId?.venueId?.venueName,
                                        DateofVisit: new Date(totalallocation?.data[selectedId].selectedVisitDate).toLocaleDateString("en-GB"),
                                        TimeofVisit: totalallocation?.data[selectedId].selectedVisitTime.visitTimeInformation
                                      }
                                    })
                                  localStorage.setItem('ActiveTask', 'Questions')
                                  handleClose("View/Print Questions")
                                }
                                }
                              >
                                <Box
                                  component="img"
                                  className="col-2"
                                  src={print}



                                ></Box>
                                View/Print Questions
                              </Button>
                              <Button
                                variant="contained"
                                onClick={() => {
                                  handleRequestNewTimeOpen();
                                }}
                                disabled={totalallocation.data[selectedId].allocationId
                                  .reportStatus !== 'unc' && totalallocation.data[selectedId].allocationId
                                    .reportStatus !== null}
                                className={clsx("w-49 d-flex flex-column ", {
                                  "bg-second ": position !== 'completed',
                                })}
                                sx={{
                                  fontSize: "14px !important", gap: 1, borderRadius: '10px',
                                  "&.Mui-disabled": {
                                    backgroundColor: "lightgrey !important",
                                    color: "#0000005A !important",
                                  },
                                }}
                              >
                                <Box
                                  component="img"
                                  className="col-2 whitespace-wrap"
                                  src={calender}
                                ></Box>
                                Request New Time
                              </Button>
                            </Box>

                          </Box>

                          {position === 'approved' &&
                            (
                              <>
                                <Divider
                                  className="my-3 d-md-block d-none"
                                  sx={{ borderColor: "#a3a3a3" }}
                                />
                                {!totalallocation.data[selectedId].allocationId?.venueId && (<Button
                                  variant="outlined"
                                  className="button-outlined transform py-3 mb-2 w-100 px-auto"
                                  sx={{
                                    fontSize: "14px !important", borderRadius: '10px',
                                    "&.Mui-disabled": {
                                      backgroundColor: "lightgrey !important",
                                      color: "#0000005A !important",
                                    },
                                  }}
                                  onClick={() => { handlegetvenuelist() }}
                                > Select Venue</Button>
                                )}
                                <Box className="d-flex gap-2">
                                  <Button
                                    variant="contained"
                                    className="bg-third py-1 px-auto"
                                    sx={{
                                      fontSize: "14px !important", borderRadius: '10px',
                                      "&.Mui-disabled": {
                                        backgroundColor: "lightgrey !important",
                                        color: "#0000005A !important",
                                      },

                                    }}
                                    disabled={totalallocation.data[selectedId].allocationId
                                      .isReportCreated && totalallocation.data[selectedId].allocationId.reportStatus !== 'unc'}
                                    onClick={() =>
                                      // totalallocation.data[selectedId].allocationId?.venueId ?
                                      createReport(
                                        totalallocation.data[selectedId].allocationId
                                          .allocationId,
                                        totalallocation.data[selectedId]
                                          .appliedAllocationId,
                                        totalallocation.data[selectedId].allocationId
                                          .isReportCreated,
                                        totalallocation.data[selectedId].allocationId
                                          .allocationClientGroup
                                      )
                                    }
                                    fullWidth
                                  >
                                    {totalallocation.data[selectedId].allocationId.reportStatus !== 'unc' && totalallocation.data[selectedId].allocationId.reportStatus !== null ? "Submitted" :
                                      totalallocation.data[selectedId].allocationId
                                        .isReportCreated
                                        ? "Edit Report"
                                        : "Create Report"}
                                  </Button>
                                  <Button
                                    variant="contained"

                                    className="custom-bg text-dark py-3 px-auto"
                                    fullWidth
                                    disabled={(totalallocation.data[selectedId].allocationId.checkOutDateTime ? true : false) || (totalallocation.data[selectedId].allocationId
                                      .isReportCreated && totalallocation.data[selectedId].allocationId.reportStatus !== 'unc')}
                                    onClick={() => {
                                      handleCheckAction(
                                        totalallocation.data[selectedId].allocationId
                                          .checkInDateTime !== null
                                          ? "checkOut"
                                          : "checkIn",

                                        totalallocation.data[selectedId].allocationId
                                          .allocationId,
                                        totalallocation.data[selectedId]
                                          .appliedAllocationId,
                                        totalallocation.data[selectedId].allocationId
                                          .allocationClientGroup,
                                        totalallocation.data[selectedId].allocationId
                                          .isReportCreated
                                      );
                                    }}
                                    sx={{
                                      fontSize: "14px !important",
                                      borderRadius: '10px',
                                      backgroundColor: totalallocation.data[selectedId].allocationId.checkOutDateTime ? 'grey !important' : '',
                                      "&.Mui-disabled": {
                                        backgroundColor: "lightgrey !important",
                                        color: "#0000005A !important",
                                      },

                                    }}
                                  >
                                    {totalallocation.data[selectedId].allocationId
                                      .checkInDateTime
                                      ? "Check-Out"
                                      : "Check-In"}
                                  </Button>
                                </Box> </>)}
                        </Box>
                      </Box>
                    )
                    : (
                      <Box className="col-md-5 flex-grow-1 d-flex flex-column col-12 p-3">
                        {selectedId !== null &&
                          totalallocation?.data[selectedId] && (
                            <Box className="h-100 w-100">
                              <form
                                className="d-flex flex-column justify-content-between h-100"
                                onSubmit={formik.handleSubmit}
                              >
                                <Box className=" w-100 flex-grow-1">
                                  <Box className="w-100">
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <StaticDatePicker
                                        key={formik.values.selectedVisitDate}
                                        value={dayjs(
                                          formik.values.selectedVisitDate
                                        )}
                                        onChange={(newValue) => {
                                          formik.setFieldValue(
                                            "selectedVisitDate",
                                            newValue
                                              ? newValue.format("YYYY-MM-DD")
                                              : ""
                                          );
                                        }}
                                        referenceDate={
                                          formik.values.selectedVisitDate
                                            ? dayjs(
                                              formik.values.selectedVisitDate
                                            )
                                            : undefined
                                        }
                                        minDate={dayjs(
                                          selectedDate,
                                          "YYYY-MM"
                                        ).startOf("month")}
                                        maxDate={dayjs(
                                          selectedDate,
                                          "YYYY-MM"
                                        ).endOf("month")}

                                        shouldDisableDate={(date) =>
                                          shouldDisableDate(
                                            date,
                                            totalallocation.data[selectedId]
                                              .allocationId.jobMonth,
                                            totalallocation.data[selectedId]
                                              .allocationId.jobYear,
                                            totalallocation.data[selectedId]
                                              .allocationId.minDate,
                                            totalallocation.data[selectedId]
                                              .allocationId.maxDate,
                                            totalallocation.data[selectedId]
                                              .allocationId.visitDaysInformation
                                          )
                                        }
                                        sx={{
                                          "& .MuiPickersCalendarHeader-switchViewButton":
                                          {
                                            display: "none",
                                          },
                                          "& .MuiPickersArrowSwitcher-root": {
                                            display: "none",
                                          },
                                          "& .MuiPickersCalendarHeader-labelContainer":
                                          {
                                            pointerEvents: "none",
                                          },
                                        }}
                                      />
                                    </LocalizationProvider>
                                  </Box>
                                  <FormControl fullWidth>
                                    <InputLabel
                                      id="demo-simple-select-label"
                                      shrinshouldk={false}
                                    >
                                      {" "}
                                      <span>
                                        Visiting Time{" "}
                                        <sup>
                                          <i className="fa-solid fa-star-of-life star"></i>
                                        </sup>
                                      </span>
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      aria-placeholder="Select the Time"
                                      value={formik.values.selectedVisitTime}
                                      onChange={(e) =>
                                        formik.setFieldValue(
                                          "selectedVisitTime",
                                          e.target.value
                                        )
                                      }
                                      MenuProps={{
                                        disablePortal: false, // Ensures dropdown is rendered inside the parent DOM
                                      }}
                                    >
                                      {filtervalue?.map((option, index) => (
                                        <MenuItem
                                          key={index}
                                          value={option.visitTimeId}
                                        >
                                          {option.visitTimeInformation}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Box>

                                <Button
                                  type="submit"
                                  className="button-primary py-2 px-5 mt-5 w-100 d-block"
                                >
                                  Update
                                </Button>
                              </form>
                            </Box>
                          )}
                      </Box>
                    )
                  } */}
                </Box>
                <Dialog open={RequestNewTime}>
                  <DialogContent>
                    <Box className="d-flex  align-items-center justify-content-end m-0">
                      <IconButton
                        onClick={() => {
                          handleRequestNewTimeClose();
                        }}
                      >
                        <CancelOutlined className="fd-2" />
                      </IconButton>
                    </Box>
                    <Typography className="form-heading text-center mb-2">
                      Request New Date and Time
                    </Typography>
                    {selectedId !== null &&
                      totalallocation?.data[selectedId] && (
                        <Box className="h-100 w-100">
                          <form onSubmit={formik.handleSubmit}>
                            <Box className=" w-100 d-flex flex-column flex-md-row justify-contnet-between">
                              <Box className="col-12 col-md-6">
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <StaticDatePicker
                                    key={formik.values.selectedVisitDate}
                                    value={dayjs(
                                      formik.values.selectedVisitDate
                                    )}
                                    onChange={(newValue) => {
                                      formik.setFieldValue(
                                        "selectedVisitDate",
                                        newValue
                                          ? newValue.format("YYYY-MM-DD")
                                          : ""
                                      );
                                      newValue && allocationCriteria?.shouldBeDifferentVisitTimeFromPreviousAllocation && handleCallAnotherCriteria(totalallocation.data[selectedId]?.allocationId, allocationCriteria?.isNeedToHideWeekend, allocationCriteria?.isNeedToHideNonWeekend, newValue.format("YYYY-MM-DD"))
                                    }}
                                    referenceDate={
                                      formik.values.selectedVisitDate
                                        ? dayjs(
                                          formik.values.selectedVisitDate
                                        )
                                        : undefined
                                    }
                                    // minDate={dayjs(
                                    //   selectedDate,
                                    //   "YYYY-MM"
                                    // ).startOf("month")}
                                    minDate={dayjs()}

                                    maxDate={dayjs(
                                      selectedDate,
                                      "YYYY-MM"
                                    ).endOf("month")}

                                    shouldDisableDate={(date) =>
                                      // {
                                      // if (totalallocation.data[selectedId]
                                      //   .allocationId.jobMonth === 12) {
                                      //   return true;
                                      // }
                                      // return 
                                      // totalallocation.data[selectedId].allocationId?.venueId?.locationType === 'region'
                                      //   ?
                                      //   shouldDisableDate(
                                      //     date,
                                      //     totalallocation.data[selectedId]
                                      //       .allocationId?.jobMonth,
                                      //     totalallocation.data[selectedId]
                                      //       .allocationId?.jobYear,
                                      //     allocationCriteria?.regionMinDate,
                                      //     allocationCriteria?.regionMaxDate,
                                      //     allocationCriteria?.regionVisitDaysInformation
                                      //   )
                                      //   :
                                      shouldDisableDate(

                                        date,
                                        totalallocation.data[selectedId]
                                          .allocationId.jobMonth,
                                        totalallocation.data[selectedId]
                                          .allocationId.jobYear,
                                        // allocationCriteria?.minDate,
                                        // allocationCriteria?.maxDate,
                                        // allocationCriteria?.visitDaysInformation
                                        totalallocation?.data[selectedId]?.allocationId?.minDate,
                                        totalallocation?.data[selectedId]?.allocationId?.maxDate,
                                        // 16,
                                        totalallocation?.data[selectedId]?.allocationId?.visitDaysInformation
                                      )
                                    }
                                    // }
                                    sx={{
                                      "& .MuiPickersCalendarHeader-switchViewButton":
                                      {
                                        display: "none",
                                      },
                                      "& .MuiPickersArrowSwitcher-root": {
                                        display: "none",
                                      },
                                      "& .MuiPickersCalendarHeader-labelContainer":
                                      {
                                        pointerEvents: "none",
                                      },
                                    }}
                                  />
                                </LocalizationProvider>
                              </Box>
                              <Divider
                                className="mx-0 mx-md-3"
                                orientation="vertical"
                                sx={{
                                  borderColor: "#00000033",
                                  border: "1px solid #00000033",
                                  height: "auto",
                                }}
                              />
                              <FormControl fullWidth>
                                <InputLabel
                                  id="demo-simple-select-label"
                                  shrink={false}
                                >
                                  {" "}
                                  <span>
                                    Visiting Time{" "}
                                    <sup>
                                      <i className="fa-solid fa-star-of-life star"></i>
                                    </sup>
                                  </span>
                                </InputLabel>
                                <Select
                                  disabled={allocationCriteria?.shouldBeDifferentVisitTimeFromPreviousAllocation && dayjs(totalallocation?.data[selectedId]?.selectedVisitDate).format('YYYY-MM-DD') === formik.values.selectedVisitDate}
                                  labelId="demo-simple-select-label"
                                  aria-placeholder="Select the Time"
                                  value={formik.values.selectedVisitTime}
                                  onChange={(e) =>
                                    formik.setFieldValue(
                                      "selectedVisitTime",
                                      e.target.value
                                    )
                                  }
                                  MenuProps={{
                                    disablePortal: false, // Ensures dropdown is rendered inside the parent DOM
                                  }}
                                >
                                  {filtervalue?.map((option: any, index: Number) => {
                                    return (
                                      <MenuItem
                                        key={index}
                                        value={option.visitTimeId}
                                      >
                                        {option.visitTimeInformation}
                                      </MenuItem>
                                    )
                                  })}
                                </Select>
                                {formik.errors.selectedVisitTime && formik.touched.selectedVisitTime && (
                                  <p style={{ color: "red", fontSize: "12px" }}>
                                    {formik.errors.selectedVisitTime}
                                  </p>
                                )}
                              </FormControl>
                            </Box>

                            <Button
                              type="submit"
                              className="button-primary py-2 mt-3 mt-md-0 px-5 mx-auto mx-md-0 ms-md-auto d-block"
                            >
                              Update
                            </Button>
                          </form>
                        </Box>
                      )}
                  </DialogContent>
                </Dialog>
              </>
            )}
          </Box>
        </Box>
      ) : (
        <Box
          className="w-100 d-flex align-items-start pt-5 justify-content-center"
          height={"calc(100vh - 140px)"}
        >
          <Box>

            <Typography
              className="text-center mt-3 fs-20 fw-bold text-main"
            // variant=""
            >
              {position === 'approved' ? "You don't have any tasks to do this month, check another month." : `You currently don't have any ${position} tasks for this month, check another month.`}
            </Typography>
          </Box>
        </Box>
      )
      }

      <Dialog
        open={OpenDeleteConfirm}
        onClose={() => { setOpenDeleteConfirm(false) }}
      >
        <DialogContent className="w-100">
          <Box className="d-flex align-items-center justify-content-end m-0">
            <IconButton
              onClick={() => {
                setOpenDeleteConfirm(false);
              }}
            >
              <CancelOutlined className="fd-2" />
            </IconButton>
          </Box>
          <Typography variant="h6" className="text-center" gutterBottom>
            {position === "applied" ? "Are you sure you want to cancel this application ?" : "You can reschedule your Job Date And Time"}
          </Typography>
          <Box
            className="d-flex my-3 align-items-center justify-content-center"
            gap={2}
          >

            {position !== "applied" && (<Button
              variant="contained"
              className="button-primary py-2 px-3"
              sx={{ fontSize: "14px !important" }}
              onClick={() => {
                setOpenCancel(false);
                setRequestNewTime(true);
                setOpenDeleteConfirm(false)
              }}
            >
              Request New Time
            </Button>
            )}
            <Button
              variant="contained"
              className="button-primary py-2 px-3"
              sx={{ fontSize: "14px !important" }}
              onClick={() => {
                setOpenCancel(true)
                setOpenDeleteConfirm(false)
              }}
            >
              Cancel Task
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      <Dialog open={OpenDialog} onClose={() => { setOpenDialog(false) }}>
        <DialogContent className="w-100">
          {(newBrief || totalallocation?.data[selectedId]?.allocationId?.venueId?.venueDescription) ? (
            <>
              <Box className="d-flex align-items-center justify-content-between m-0">
                <Typography variant="h5" className="fw-bold">{newBrief?.data[0]?.title}</Typography>
                <IconButton
                  onClick={() => {
                    handleDialogClose();
                  }}
                >
                  <CancelOutlined className="fd-2" />
                </IconButton>
              </Box>
              {(newBrief || totalallocation?.data[selectedId]?.allocationId?.venueId?.venueDescription) ? (
                <>
                  <Box
                    overflow="auto"
                    dangerouslySetInnerHTML={{
                      __html:
                        newBrief?.data[0]?.description || "",
                    }}
                  />
                  <Button
                    className="button-primary  mx-auto py-2 px-4 d-block"
                    onClick={() => {
                      handleDialogClose();
                    }}
                  >
                    Continue
                  </Button>
                </>
              ) : (
                <Typography variant="h6" className="text-center fw-bold">
                  Brief not available
                </Typography>
              )}
            </>
          ) : (
            <Typography variant="subtitle1">No Data Found</Typography>
          )}
        </DialogContent>
      </Dialog>

      <Dialog
        open={OpenCancel}
        className="cancel-job"
        onClose={() => {
          setOpenCancel(false);
        }}
      >
        <DialogContent className="w-100">
          <Box className="d-flex  align-items-center justify-content-end m-0">
            <IconButton
              onClick={() => {
                setOpenCancel(false);
              }}
            >
              <CancelOutlined className="fd-2" />
            </IconButton>
          </Box>
          <Typography variant="h6" className="text-center" gutterBottom>
            Cancel Task{" "}
          </Typography>
          <Box className='my-2'>
            <FormControl fullWidth>
              <InputLabel shrink={false}>Select Reason for Cancellation</InputLabel>
              <Select displayEmpty value={CancelReason} onChange={(e) => { setCancelReason(e.target.value) }} >

                <MenuItem value=''><em>Select Reason</em></MenuItem>
                <MenuItem value='I am unwell or have a medical appointment.'>I am unwell or have a medical appointment.</MenuItem>
                <MenuItem value='I have a family or personal emergency.'>I have a family or personal emergency.</MenuItem>
                <MenuItem value='I am no longer available on the scheduled date.'>I am no longer available on the scheduled date.</MenuItem>
                <MenuItem value='I cannot complete the task due to transport or access issues.'>I cannot complete the task due to transport or access issues.</MenuItem>
                <MenuItem value='I do not feel comfortable completing this task.'>I do not feel comfortable completing this task.</MenuItem>
                <MenuItem value='I accepted the task by mistake.'>I accepted the task by mistake.</MenuItem>
                <MenuItem value='I cannot meet the deadline for submitting the report.'>I cannot meet the deadline for submitting the report.</MenuItem>
                <MenuItem value='I did not fully understand the requirements.'>I did not fully understand the requirements.</MenuItem>
                <MenuItem value='Other'>Other (please specify)</MenuItem>
              </Select>
              {(CancelReason.length < 1 && isshowerror) && (<Typography variant="caption" className="text-danger">Select Reason</Typography>)}
            </FormControl>
            {CancelReason === "Other" && (<FormControl fullWidth className="mt-3">
              <InputLabel shrink={false}>Enter Your Reason</InputLabel>
              <TextField
                value={CancelReason2}
                onChange={(e) => { setCancelReason2(e.target.value) }}
              />
              {(CancelReason2.length < 1 && isshowerror) && (<Typography variant="caption" className="text-danger">Enter Your Reason</Typography>)}
            </FormControl>)}
          </Box>
          <Box
            className="d-flex mt-3 align-items-center justify-content-center"
            gap={2}
          >
            <Button
              variant="contained"
              className="button-primary py-2 px-3"
              sx={{ fontSize: "14px !important" }}
              onClick={() => {
                CancelJob(selectedId);
                setisshowerror(true)
              }}
            >
              Cancel Task
            </Button>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog sx={{ width: { xs: "300px", md: "500px" } }} className="mx-auto" open={isneeddatechange} onClose={() => { setisneeddatechange(false) }}>
        <Box className='p-2 w-100'>
          <Box className='d-flex w-100 justify-content-end'>

            <IconButton onClick={() => { setisneeddatechange(false) }}><CancelOutlined /></IconButton>
          </Box>
          <Box className='p-3'>
            <ul>
              {(allocationCriteria?.shouldBeDifferentDayFromPreviousMonth === true && dayjs(allocationCriteria?.lastJobVisitedDate).format('dddd') === dayjs(totalallocation?.data[selectedId]?.selectedVisitDate).format('dddd')) && (
                <li>
                  <Typography>Two consecutive months cannot be assigned to {dayjs(totalallocation?.data[selectedId]?.selectedVisitDate).format('dddd')}</Typography>
                  <Typography>
                    If there is no suitable date, contact{" "}
                    <a href="mailto:bryan@mysterymanagement.com.au">
                      bryan@mysterymanagement.com.au
                    </a>{" "}
                    for a solution.
                  </Typography>
                </li>
              )
              }
              {allocationCriteria?.isNeedToHideWeekend && isWeekend(totalallocation?.data[selectedId]?.selectedVisitDate) && (
                <li>
                  <Typography>⁠⁠A maximum of {allocationCriteria?.maxConsecutiveWeekendDays} consecutive months can be assigned to weekends. Please choose a weekday instead.</Typography>

                </li>
              )}
              {allocationCriteria?.isNeedToHideNonWeekend && !isWeekend(totalallocation?.data[selectedId]?.selectedVisitDate) && (
                <li>
                  <Typography>⁠⁠A maximum of {allocationCriteria?.maxConsecutiveNonWeekendDays} consecutive months can be assigned to weekdays. Please choose a weekend instead.</Typography>
                </li>
              )}

            </ul>
            <Typography
              component="div"
              dangerouslySetInnerHTML={{ __html: `${allocationCriteria?.venueClosePlus3Days ? `<p>DO NOT audit or mysteryshop this store between ${dayjs(allocationCriteria?.venueClosePlus3Days).format('DD/MM/YYYY') ?? ""} to ${dayjs(allocationCriteria?.venueOpenMinus7Days).format("DD/MM/YYYY") ?? ""} inclusive</p>` : ""}${allocationCriteria?.venueMessage !== null ? `<p>${allocationCriteria?.venueMessage}` : ""}` }}
            />

          </Box>
        </Box>
      </Dialog>


      <Dialog sx={{ width: { xs: "300px", md: "500px" } }} className="mx-auto" open={isshopperconfirm} onClose={() => { setisshopperconfirm(false) }}>
        <Box className='p-2 w-100'>
          <Box className='d-flex w-100 justify-content-end'>

            <IconButton onClick={() => { setisshopperconfirm(false) }}><CancelOutlined /></IconButton>
          </Box>
          <Box className='p-2'>
            <Typography variant="h6" gutterBottom className="fw-bold">Attendance confirmation</Typography>
            <Typography>Your attendance confirmation is pending. Please confirm or update your date and time soon to avoid task removal.</Typography>
            <Box className='mt-3 d-flex align-items-center gap-3 justify-content-center'>
              <Button onClick={() => { setisshopperconfirm(false) }} variant="outlined" className="button-primary-outlined px-4 py-2 border-20">
                Cancel
              </Button>
              <Button onClick={() => { approvebyShopper() }} className="button-primary text-white px-4 py-2">
                Confirm
              </Button>
            </Box>
          </Box>
        </Box>
      </Dialog>
      {/* showselectvenue */}
      <Dialog open={showselectvenue} sx={{ width: { xs: "300px", md: "500px" } }} className="mx-auto">
        <Box className='h-100 w-100 bg-light p-3'>
          <Box className='d-flex align-items-center justify-content-between'>
            <Typography variant="h6" className="fw-bold">Select Venue</Typography>
            <IconButton onClick={() => { setshowselectvenue(false) }}><CancelOutlined /></IconButton>
          </Box>
          <hr />
          <Box className='w-100 d-flex flex-column'>
            <FormControl fullWidth>
              <Select value={selectedVenueforTransport} onChange={(e) => { setselectedVenueforTransport(e.target?.value) }}>

                {selectvenuelist?.map((item: any, index: number) => (
                  <MenuItem key={index} value={item?.venueId}>{item?.venueName}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button
              variant="contained"
              className="bg-third py-2 mt-3 mx-auto  px-auto"
              sx={{
                fontSize: "14px !important", borderRadius: '10px',
                "&.Mui-disabled": {
                  backgroundColor: "lightgrey !important",
                  color: "#0000005A !important",
                },

              }}
              onClick={() =>
                selectedVenueforTransport ? handleselectedvenue() : window.alert("Please select venue")
              }
            >Submit</Button>
          </Box>
        </Box>
      </Dialog >


      <Dialog
        open={OpenTrainingDialog}
        className='mx-auto p-0'
        PaperProps={{
          sx: {
            width: "fit-content",
            maxWidth: "fit-content !important",
            padding: 0,
            // height: '500px',
            height: '75vh',
            overflow: 'auto'
          },
        }}
      >
        <Box className='p-3 d-flex flex-column h-100'>
          <Box className='d-flex align-items-center justify-content-between'>
            <Typography variant="h5">Select Training Slot</Typography>
            <IconButton onClick={() => { setSelectedSlot([]); setOpenTrainigDialog(false); setTrainingSlots([]) }}><CancelOutlined /></IconButton>
          </Box>
          <Box className="d-flex my-1 justify-content-between align-items-center mb-3">
            <Button
              variant="outlined"
              className="button-primary-outlined py-1 px-3"
              onClick={handleBack}
              disabled={currentPage === 0}

            >
              Back
            </Button>

            <Button
              onClick={handleNext}
              disabled={end >= dates.length}
              variant="outlined"
              className="button-primary-outlined py-1 px-3"            >
              Next
            </Button>
          </Box>
          <Box className='d-flex mt-2' flex={1} alignItems={'start'} gap={{ xs: "10px", md: '40px' }}>
            {visibleDates?.map((date) => (
              <div
                key={date}
                style={{
                  // padding: "15px",
                  borderRadius: "8px",
                  width: "fit-content",

                }}
              >
                <Box className='p-2 mb-3 px-3 bg-second text-light mx-auto' borderRadius={'50%'} width={'fit-content'}>
                  <Typography fontSize={'10px'} fontWeight={'bold'} style={{ textAlign: "center" }}>
                    {dayjs(date, "YYYY-MM-DD")?.format("ddd")}
                  </Typography>
                  <Typography fontSize={'14px'} fontWeight={'bold'} lineHeight={'normal'} style={{ textAlign: "center" }}>
                    {dayjs(date, "YYYY-MM-DD")?.format("DD")}
                  </Typography>
                </Box>

                {trainingSlots[date]?.map((slot: any) => {
                  const isSelected = selectedSlot?.slotId === slot.slotId;

                  return (
                    <div className="d-flex px-3 py-2 flex-column justify-content-center align-items-center"
                      style={{
                        marginTop: "10px",
                        borderRadius: "6px",
                        cursor: "pointer",
                        fontSize: '12px',
                        border: isSelected ? "2px solid #ADB792" : "1px solid #ccc",
                        color: isSelected ? "white" : "black",
                        backgroundColor: isSelected ? "#ADB792" : "#fff",
                        fontWeight: isSelected ? "bold" : "normal",
                        transition: "0.2s",
                        textAlign: "center",
                        whiteSpace: 'nowrap'
                      }}
                      onClick={() => setSelectedSlot(slot)}
                    >
                      <div
                        key={slot.slotId}
                      >
                        {dayjs.utc(slot.slotStart).local().format("hh:mm A")} - {dayjs.utc(slot.slotEnd).local().format("hh:mm A")}
                      </div>
                      <Typography variant="caption" className="p-0 m-0 text-center w-100">{slot.editorFirstName}</Typography>
                    </div>
                  );
                })}
              </div>
            ))}
          </Box>
          <hr />
          <Box className='d-flex  justify-content-end'>
            <Button
              onClick={handleSubmit}
              className="bg-third py-2 ms-auto px-3 mb-2  text-light"
            >
              Book Slot
            </Button>
          </Box>
        </Box>
      </Dialog>
      <div className="full-dilaog">
        <Dialog open={OpenNewBriefReadDialog} className="full-dilaog d-flex flex-column" fullScreen>
          <DialogContent className="p-0" sx={{ flex: 1 }}>
            {OpenNewBriefReadDialog && newBrief?.data && (<ReadBrief key={tempallocationCriteria} isVewOnly={!tempallocationCriteria?.isQuizRequired} handleClose={() => { setOpenNewBriefReadDialog(false) }} newBrief={newBrief?.data} title={newBrief?.mainTitle} selecetedAllocation={totalallocation?.data[tempAllocation]?.allocationId} setSelectedOptions={setSelectedOptions} setIsQuizSubmitted={setIsQuizSubmitted} selectedOptions={selectedOptions} QuizList={QuizList} handleOpenQuiz={handleOpenQuiz} submitform={handleCheckQuizandCreateReport} />)}
          </DialogContent>
        </Dialog>
      </div>
      {loading && <Loading />
      }
    </Box >
  );
}

export default MyTask;
